<template>
    <div>
        <Header :class="showMultiScreenBtn?'':'headerHeight'">
            <Menu mode="horizontal" theme="dark" active-name="1" @on-select="onMenuSelect" :style="{paddingTop:showMultiScreenBtn?'':'0px'}">
                <div class="layout-logo">
                    <img v-show="!islogoshow" src="../assets/images/logo.png" />
                </div>
                <div class="menuList" :class="showMultiScreenBtn?'layout-nav-left':'layout-nav-right'">
                    <!-- <div class='incentives' :style="{display:!showMultiScreenBtn?'inline-block':'none'}"><img src="../assets/images/taxmatch/hui.png" /><span @click="directto1()">优惠政策匹配</span></div>
                    <div class='incentives2' :style="{display:showMultiScreenBtn?'inline-block':'none'}"><img src="../assets/images/taxmatch/hui2.png"  @click="directto1()" /></div> -->
                    <!-- <MenuItem class='freetry1' name="11" :style="{display:true?'inline-block':'none',marginTop:'1px'}">优惠政策匹配</MenuItem> -->
                    <MenuItem class='freetry' name="2" :style="{display:!showLoginUserMenu?'inline-block':'none',marginTop:'1px'}">注册</MenuItem>
                    <MenuItem name="1">
                    <span v-if="showLoginBtn">
                        <span>
                            <img src="../assets/images/img/user_unlogin.png" height="22" style="position: relative;top:4px;right: 2px;" />
                        </span>
                    </span>
                    <span v-else>
                        <span v-if="sta.mallver === 'v1'">
                            <span>
                                <img src="../assets/images/img/user_seed.png" height="18" style="position: relative;top:3px;right: 2px;" />
                                <img src="../assets/images/img/user_seed_txt.png" height="12" />
                            </span>
                        </span>
                        <span v-else>
                            <span v-if="sta.maxopendocnum == 999999">
                                <img src="../assets/images/img/user_pro.png" height="18" style="position: relative;top:3px;right: 2px;" />
                                <img src="../assets/images/img/user_pro4.png" height="12" />
                            </span>
                            <span v-else>
                                 <img src="../assets/images/img/user_trial.png" height="18" style="position: relative;top:3px;right: 2px;" />
                                <img src="../assets/images/img/user_trial4.png" height="12" />
                            </span>
                        </span>
                    </span>
                    <span class="refreshbtn"><Button size="small" type="text" @click="showlogin" :style="{display:showLoginBtn?'inline':'none'}" ghost>登录</Button></span>
                    <UserMenu ref="myUserMenu" :style="{display:showLoginUserMenu?'inline-block':'none'}" @logout="userLogout" @pwdReset="passwdReset" @pwdEdit="passwdEdit" @showUserinfo="showUser" @showManagePwd="showMngPwd" @showpay="showpaymodal" @showvip="showvipmodal" @showChangePhone="showcp" @showSmsEditAcc="showsmswxaccount" @showBindWechat="showBindWechat" @showBindPhone="showbp" @showResetWxToken="showrwt" @show-promo-code="showPromoCode"></UserMenu>
                    </MenuItem>
                    <MenuItem name="3" :style="{display:showMultiScreenBtn?'inline-block':'none'}">
                    <Icon type="ios-browsers" />
                    <Button type="warning" size="small" style="width:80px;">关屏</Button>
                    </MenuItem>
                    <MenuItem class="refreshbtn" name="4">
                    <Button type="text" icon="md-refresh" ghost size="small" style="width:100px;display:inline-block;margin-left:-30px;" @click="refreshMain">刷新</Button>
                    </MenuItem>
                </div>
            </Menu>
        </Header>
        <!--   :z-index="1501" -->
        <Modal class="userregpannel" v-model="modal1" width="760" :footer-hide="true" :mask-closable="false" @on-cancel="cancel">
            <!-- <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>注册账号</span>
            </p> -->
            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;">
                <Tabs class="tabreg" size="small" v-model="regTabValue" @on-click="tabsClickReg" style="padding-top:10%;">
                    <TabPane name="1" label="手机注册" :disabled="isWxRegGetTelNum">
                        <UserReg style="width:400px;" ref="userinfo" @regok="reg_ok"></UserReg>
                        <div><Button type="primary" style="width:65%;" size="large" @click="ok">提交注册</Button></div>
                        <div style="padding-top: 20px;">已有账号?<a @click="switchLogin">立即登录</a></div>
                    </TabPane>
                    <TabPane name="3" label="微信注册">
                        <WechatLoginCustom style="width:400px;" v-if="!isWxRegGetTelNum" ref="mywechatreg2" :modelType=1 />
                        <UserReg v-else ref="userinfowxreg" @regok="reg_ok"></UserReg>
                    </TabPane>
                </Tabs>
            </div>
            <!-- <div slot="footer" :style="{display:isShowRegFooter?'block':'none'}">
                <Button type="text" size="large" @click="cancel">取消</Button>
                <Button type="primary" size="large" @click="ok">提交</Button>
            </div> -->
        </Modal>
        <Modal class="linkwxpannel" v-model="modalBindWechat" width="760" :footer-hide="true" :mask-closable="false" @on-cancel="cancelBindWx">
            <div class="wxlinkdiv">
                <img src="../assets/images/wx_link.png" style="margin-left:12%;margin-top:20%;width: 282px;height: 131px;display: inline-block;">
                <div style="position:absolute;top:160px;left:5%;width: 230px;margin-top: 6%;">
                    <p class="linelinktitle">关联微信</p>
                    <p class="linelink">云端文件变动及时提醒</p>
                    <p class="linelink1">云端文件效力变化时及时知晓</p>
                    <p class="linelink">快捷登录</p>
                    <p class="linelink1">扫码快捷登录</p>
                </div>
            </div>
            <div style="float: left;padding-left:10px;">
                <Divider class="linkdivider" type="vertical" />
            </div>
            <div style="text-align:center;height: 468px;">
                <div style="padding-top: 10%;height: 468px;">
                    <!-- <div class="panneltitle">关联微信</div> -->
                    <WechatLoginCustom ref="mywechatbind2" style="padding-top: 20px;" :modelType=3 />
                </div>
            </div>
            <!-- <div slot="footer" :style="{display:isShowBindWxFooter?'block':'none'}">
                <Button type="text" size="large">取消</Button>
                <Button type="primary" size="large">提交</Button>
            </div> -->
        </Modal>
        <Modal class="resetlinkpannel" v-model="modalResetWxToken" width="760" :footer-hide="true" :mask-closable="false" @on-cancel="wxTokenCancel">
            <!-- <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>正在重置微信关联</span>
            </p> -->
            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;">
                <div style="padding-top: 10%;height: 468px;">
                    <div class="panneltitle">重置微信关联</div>
                    <UserResetWXToken style="width:380px;float: right;margin-right:30px;margin-top:30px;" ref="resetwxtoken" @reset-wxtoken="resetWXtoken"></UserResetWXToken>
                    <div style="display:block;width:395px;float:right;"><Button style="width:330px;float:left;" size="large" type="primary" @click="wxResetTokenSubmit">重置微信</Button></div>
                </div>
            </div>
            <!-- <div slot="footer">
                <Button type="text" size="large" @click="wxTokenCancel">取消</Button>
                <Button type="primary" size="large" @click="wxResetTokenSubmit">提交</Button>
            </div> -->
        </Modal>
        <Modal class="pwdresetpannel" v-model="modalPwd" width="780" :footer-hide="true" :mask-closable="false" @on-cancel="pwdCancel">
            <!-- <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>正在重置您的密码</span>
            </p> -->
            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;">
                <div style="padding-top: 12%;height: 468px;">
                    <div class="panneltitle">重置密码</div>
                    <UserPwd style="display:inline-block;width:340px;margin-top: 30px;" ref="upwd" @pwdok="pwd_ok"></UserPwd>
                    <div style="display:block;width:395px;float:right;"><Button style="width:330px;float:left;" size="large" type="primary" @click="pwdSubmit">重置密码</Button></div>
                </div>
            </div>
            <!-- <div slot="footer">
                <Button type="text" size="large" @click="pwdCancel">取消</Button>
                <Button type="primary" size="large" @click="pwdSubmit">提交</Button>
            </div> -->
        </Modal>
        <Modal class="editpwdpannel" v-model="modalEditPwd" width="780" :footer-hide="true" :mask-closable="false" @on-cancel="pwdEditCancel">
            <!-- <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>正在修改您的密码</span>
            </p> -->
            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;">
                <div style="padding-top: 10%;height: 468px;">
                    <div class="panneltitle">修改密码</div>
                    <EditPwd style="display:inline-block;width:340px;margin-top: 30px;" ref="editpwd" @onEditPwd="editPassword" />
                    <div style="display:block;width:395px;float:right;"><Button style="width:330px;float:left;" size="large" type="primary" @click="editPwdSubmit">确认修改</Button></div>
                </div>
            </div>
            <!--  <div slot="footer">
                <Button type="text" size="large" @click="pwdEditCancel">取消</Button>
                <Button type="primary" size="large" @click="editPwdSubmit">提交</Button>
            </div> -->
        </Modal>
        <!--   :z-index="1501" -->
        <Modal class="userloginpannel" v-model="modalLogin" width="760" :mask-closable="false" title='' :closable="true" :footer-hide="true" @on-cancel="loginCannel">
            <!--  <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>登录您的账号</span>
            </p> -->
            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;">
                <Tabs class="tablogin" size="small" v-model="loginTabValue" @on-click="tabsClick" style="padding-top:10%;">
                    <TabPane name="1" label="账号登录">
                        <UserLogin style="width:400px;" ref="ulogin" @loginok="login_ok" @loginerr="login_err" @on-valid-success="lockLoginButton" @createAccount="createAcc" @pwdReset="passwdReset" @on-enterkey="loginSubmit"></UserLogin>
                    </TabPane>
                    <TabPane name="2" label="验证码登录">
                        <SmsLogin style="width:400px;" ref="uSmsLogin" @on-valid-success="lockLoginButton" @loginerr="login_err" @createAccount="createAcc" @pwdReset="passwdReset" @loginok="login_ok" @on-enterkey="loginSubmit" />
                    </TabPane>
                    <!--    <TabPane name="3" label="微信登录">
                        <WechatLogin ref="mywechatlogin" />
                    </TabPane> -->
                    <TabPane name="4" label="微信登录">
                        <WechatLoginCustom ref="mywechatlogin2" :modelType=2 />
                    </TabPane>
                </Tabs>
            </div>
            <!--  由于登录UI优化，不再显示页脚 -->
            <!-- <div slot="footer" :style="{display:isShowLoginFooter?'block':'none'}">
                <Button type="text" size="large" @click="loginCannel">取消</Button>
                <Button type="primary" :disabled="isLoginButtonDisable" size="large" @click="loginSubmit">登录</Button>
            </div> -->
        </Modal>
        <Modal v-model="modalSetPwd" width="650" :mask-closable="false" @on-cancel="cancel">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>设置您的账号及密码</span>
            </p>
            <div style="text-align:center" v-if="modalSetPwd">
                <!-- <UserRegSetPwd ref="userregsetpwd" @regSetPwdOk="regSetPwdOk" @show-agreement="showAgreement"></UserRegSetPwd> -->
                <UserReg2 ref="userreg2" @regInfoReady="regSetPwdOk"></UserReg2>
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancel">取消</Button>
                <Button type="primary" size="large" @click="regSetPwdSubmit">提交</Button>
            </div>
        </Modal>
        <Modal class="pwdresetpannel2" v-model="modalPwdSubmit" width="750" :footer-hide="true" :mask-closable="false" @on-cancel="pwdSubmitCancel">
            <!-- <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>请输入并确认您的密码</span>
            </p> -->
            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;">
                <div style="padding-top: 12%;height: 468px;">
                    <div class="panneltitle">确认密码</div>
                    <GetPwdSubmit style="display:inline-block;width:340px;margin-top: 30px;" ref="getpwdsubmit" @pwdSubmitok="pwdSubmitok"></GetPwdSubmit>
                    <div style="display:block;width:380px;float:right;"><Button style="width:330px;float:left;" size="large" type="primary" @click="getPwdSubmit">确认提交</Button></div>
                </div>
            </div>
            <!-- <div slot="footer">
                <Button type="text" size="large" @click="pwdSubmitCancel">取消</Button>
                <Button type="primary" size="large" @click="getPwdSubmit">提交</Button>
            </div> -->
        </Modal>
        <!--  :z-index="1501" -->
        <Modal v-model="modalPages" width="450" :mask-closable="false" @on-cancel="ClearDocsCancel">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>请选择您要关闭的文档</span>
            </p>
            <div style="text-align:center">
                <DocManage ref="DocMng"></DocManage>
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="ClearDocsCancel">取消</Button>
                <Button type="primary" size="large" @click="sumitClearDocs">确定</Button>
            </div>
        </Modal>
        <Modal v-model="modalUserInfo" width="450" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-contact" size="18" />
                <span>账号信息</span>
            </p>
            <div style>
                <UserInfo ref="UserInfo" />
            </div>
            <div slot="footer">
                <Button type="primary" size="large" @click="closeUserinfo">关闭</Button>
                <!--  <Button type="primary" size="large" @click="sumitClearDocs">确定</Button> -->
            </div>
        </Modal>
        <Modal v-model="modalManagePwd" fullscreen :mask-closable="false" class="mp">
            <p slot="header" style="color:white;text-align:center;font-size:16px;">
                <Icon type="md-refresh" size="20" />
                <span>重置成员密码</span>
            </p>
            <div style="height:100%;">
                <ManagePwd />
            </div>
            <div slot="footer">
                <Button type="primary" size="large" @click="closeMngPwd">关闭</Button>
                <!--  <Button type="primary" size="large" @click="sumitClearDocs">确定</Button> -->
            </div>
        </Modal>
        <Modal v-model="modalPromo" width="450" :mask-closable="false" @on-cancel="cancelPromo">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>推广码</span>
            </p>
            <div style="text-align:center;height: 480px;">
                <MyPromo ref="promocode" @bind-distri="bindDistri" @showCustomer="showMyCustomer" />
            </div>
            <div slot="footer">
                <Button type="primary" size="default" @click="cancelPromo">关闭</Button>
            </div>
        </Modal>
        <Modal class="customerpannel" :footer-hide="true" v-model="modalCustomer" width="450" :mask-closable="false" @on-cancel="cancelCustomer">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>我的客户({{mycustomer_total}})</span>
            </p>
            <div style="text-align:center;height: 580px;">
                <MyCustomer v-if="modalCustomer" ref="mycustomers" @on-success="onCustomers_loading_over" />
            </div>
            <!-- <div slot="footer">
                <Button type="primary" size="default" @click="cancelCustomer">关闭</Button>
            </div> -->
        </Modal>
        <Modal v-model="modalBindDistriButor" width="850" :styles="{top: '20px'}" :mask-closable="false" @on-cancel="cancelDistributor">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>绑定分销商</span>
            </p>
            <div style="text-align:center;height: 750px;">
                <Distributor ref="bindmydistributor" @close="cancelDistributor" />
            </div>
            <div slot="footer">
                <Button type="primary" size="default" @click="cancelDistributor">关闭</Button>
            </div>
        </Modal>
        <Modal v-model="modalPay" width="850" :styles="{top: '50px'}" :mask-closable="false" class="vipmodal">
            <p slot="header" style="color:#ed4014;text-align:center;font-size:16px;">
                <!-- <Icon type="md-refresh" size="20" /> -->
                <span>续费账号等级</span>
            </p>
            <div style="height:100%;">
                <!--  <UserPay @closeModal="closepaymodal" ref="uPay" /> -->
                <UserProductPay @closeModal="closepaymodal" @payComplete="reloadmyproduct" ref="uPay" />
            </div>
            <div slot="footer">
                <Button size="default" @click="closepaymodal">关闭</Button>
                <Button type="primary" size="default" @click="commitRenewalData">去支付</Button>
            </div>
        </Modal>
        <Modal v-model="modalVipPay" width="850" :styles="{top: '20px'}" :mask-closable="false" class="vipmodal">
            <p slot="header" style="color:#ed4014;text-align:center;font-size:16px;">
                <!-- <Icon type="md-refresh" size="20" /> -->
                <span>续购VIP升级权限</span>
            </p>
            <div style="height:100%;">
                <UserVipPackagePay @disablePay="disablePayment" @closeModal="closevippaymodal" @payComplete="reloadmyvip" ref="uVipPay" />
            </div>
            <div slot="footer">
                <Button size="default" @click="closevippaymodal">关闭</Button>
                <Button :disabled="isDisablePay" type="primary" size="default" @click="commitVipRenewalData">去支付</Button>
            </div>
        </Modal>
        <Modal v-model="modalMyVip" width="920" :styles="{top: '20px'}" :mask-closable="false" class="vipmodal">
            <p slot="header" style="color:#ed4014;text-align:center;font-size:16px;">
                <!-- <Icon type="md-refresh" size="20" /> -->
                <span>我的账号</span>
            </p>
            <div style="height:100%;">
                <MyVip v-if="modalMyVip" ref='myVipPage' />
            </div>
            <!-- <div slot="footer">
        <Button type="primary" size="large" @click="closeMngPwd">关闭</Button>
         <Button type="primary" size="large" @click="sumitClearDocs">确定</Button>
      </div>-->
        </Modal>
        <Modal v-model="modalAgreement" width="800" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>用户协议</span>
            </p>
            <div style="height:500px;overflow-y: scroll;">
                <Agreement ref="agreementContent"></Agreement>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="closeAgreement">同意并继续</Button>
                <!--  <Button type="primary" size="large" @click="sumitClearDocs">确定</Button> -->
            </div>
        </Modal>
        <Modal v-model="modalStateMent" width="500" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>特别声明</span>
            </p>
            <div style="height:400px;overflow-y: auto;">
                <Statement ref="statementContent"></Statement>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="closeStateMent">我知道了</Button>
                <!--  <Button type="primary" size="large" @click="sumitClearDocs">确定</Button> -->
            </div>
        </Modal>
        <Modal class="phoneresetpannel" v-model="modalChangePhone" width="750" :footer-hide="true" :mask-closable="false" @on-cancel="cpCancel">
            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;">
                <div style="padding-top: 8%;">
                    <div class="panneltitle">更换手机号码</div>
                    <div style="padding-top: 20px;display: inline-block;">
                        <Steps :current="0">
                            <Step title="验证身份"></Step>
                            <Step title="修改手机"></Step>
                            <Step title="完成"></Step>
                        </Steps>
                    </div>
                </div>
                <div style="text-align:center">
                    <ChangePhone style="display:inline-block;width:420px;padding-top: 20px;" ref="cpInfo" @popCpInfo="sumitCpInfo" />
                    <div style="display:block;width:420px;float:left;"><Button style="width:230px;" size="large" type="primary" @click="cpSubmit">下一步</Button></div>
                </div>
            </div>
            <!-- <div slot="footer">
                <Button type="text" size="large" @click="cpCancel">取消</Button>
                <Button type="primary" size="large" @click="cpSubmit">提交</Button>
            </div> -->
        </Modal>
        <Modal class="phoneresetpannel" v-model="modalChangePhoneSubmit" width="750" :footer-hide="true" :mask-closable="false" @on-cancel="cpsCancel">
            <!-- <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>更换手机号码</span>
            </p> -->
            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;">
                <div style="padding-top: 8%;">
                    <div class="panneltitle">更换手机号码</div>
                    <div style="padding-top: 20px;display: inline-block;">
                        <Steps :current="1">
                            <Step title="验证身份"></Step>
                            <Step title="更换号码"></Step>
                            <Step title="完成"></Step>
                        </Steps>
                    </div>
                </div>
                <div style="text-align:center;">
                    <ChangePhoneSubmit style="display:inline-block;width:420px;padding-top: 20px;" ref="cpsInfo" @popCpsInfo="sumitCpsInfo" />
                    <div style="display:block;width:420px;float:left;"><Button style="width:230px;" size="large" type="primary" @click="cpsSubmit">确认更换</Button></div>
                </div>
            </div>
            <!--  <div slot="footer">
                <Button type="text" size="large" @click="cpsCancel">取消</Button>
                <Button type="primary" size="large" @click="cpsSubmit">提交</Button>
            </div> -->
        </Modal>
        <Modal v-model="modalCheckPermission" width="800" :mask-closable="false" :closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>验证用户账号信息</span>
            </p>
            <div style="height:100px;text-align: center;">
                <p>
                    <Icon size="50" type="md-alert" color="#ff9900" />
                </p>
                <p>{{loginMsg}}</p>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="logoff">退出登录</Button>
                <Button v-if="sta.showmallbutton" type="warning" size="large" @click="goStore">在线商城</Button>
            </div>
        </Modal>
        <Modal v-model="modalShowOtherNotice" width="800" :mask-closable="false" :closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>提示</span>
            </p>
            <div style="height:130px;text-align: center;">
                <p>
                    <Icon size="50" type="md-alert" color="#ff9900" />
                </p>
                <br />
                <p>{{showServerOtherMessage}}</p>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="setOtherNoticeRead">确定</Button>
            </div>
        </Modal>
        <Modal v-model="modalCheckStatus" width="800" :mask-closable="false" :closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>提示</span>
            </p>
            <div style="height:130px;text-align: center;">
                <p>
                    <Icon size="50" type="md-alert" color="#ff9900" />
                </p>
                <br />
                <p>{{showServerMessage}}</p>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="shutDownStatusModal">关闭</Button>
                <Button v-if="sta.showmallbutton" type="warning" size="large" @click="goStore2">在线商城</Button>
            </div>
        </Modal>
        <Modal v-model="modalNoPermission" width="800" :mask-closable="false" :closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>提示</span>
            </p>
            <div style="height:130px;text-align: center;">
                <p>
                    <Icon size="50" type="md-alert" color="#ff9900" />
                </p>
                <br />
                <p v-html="modalNoPermissionContent"></p>
                <!-- <p>{{modalNoPermissionContent}}</p> -->
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="shutDownNoPermissionModal">关闭</Button>
                <Button type="warning" size="large" @click="goStore3">在线商城</Button>
            </div>
        </Modal>
        <Modal v-model="modalEditAccountSmsCode" width="450" :mask-closable="false" @on-cancel="cancel">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>修改账号</span>
            </p>
            <div style="text-align:center">
                <SMSEditWeAcc ref="smsCheckMyWxAcc" @wxSmsCodeCheckOk="wxCheckSmsOK"></SMSEditWeAcc>
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelsmswxaccount">取消</Button>
                <Button type="primary" size="large" @click="checkSmsWxEditAcc">提交</Button>
            </div>
        </Modal>
        <Modal v-model="modalBindPhone" width="450" :mask-closable="false" :closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>绑定手机号</span>
            </p>
            <div style="height:220px;text-align: center;">
                <p>
                    <BindPhone ref="myBindPhone" @popBpInfo="sumitBpInfo" />
                </p>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="bindPhoneCancel">关闭</Button>
                <Button type="warning" size="large" @click="bindPhoneSubmit">确认绑定</Button>
            </div>
        </Modal>
        <Modal v-model="modal11" fullscreen title="云擎打印">
            <div ref="myprinter1" style="width:100%">
            </div>
        </Modal>
        <Modal v-model="modal12" :mask-closable="false">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>确认邮箱地址</span>
            </p>
            <div style="width:auto;">
                <Input v-model="user_email" prefix="md-mail" placeholder="请输入邮箱地址" style="width: 100%;" />
            </div>
            <div slot="footer">
                <Button type="primary" size="large" long @click="sendMail">发送到邮件</Button>
            </div>
        </Modal>
        <Modal class="pwdresetpannel" v-model="modalRiskDetection" width="780" :footer-hide="true" :mask-closable="false" @on-cancel="rdCancel">

            <div style="width:300px;float: left;margin-right: 10px;">
                <img src="../assets/images/login_form.png">
                <div style="position:absolute;top:200px;left:5%;">
                    <p class="line1">众智云擎</p>
                    <p class="line2">专业税法检索 实时智能管家</p>
                    <p class="line3">WELCOME</p>
                </div>
            </div>
            <div style="text-align:center;height: 468px;width: 99%;">
                <div style="padding-top: 12%;height: 468px;">
                    <div class="rdpanneltitle">中软云企申请获得以下信息</div>
                    <div class="rddesctitle">获得您的用户信息(昵称、手机号码等)</div>
                    <div class="rdcontent">
                        <div class="div1"><img src="https://www.holywiser.com/img/logo.033407ab.png" /></div><div class="divdot">···</div><div class="div2"><img src="http://lxyq.cssyq.com.cn:8443/assets/logo-e2c7463a.png"></img></div>
                    </div>
                    <div style="display:block;width:395px;float:right;margin-top: 10px;"><Button style="width:330px;float:left;" size="large" type="primary">授权获取</Button>

                    </div>
                    <div style="display:block;width:395px;float:right;margin-top: 10px;"><Button style="width:330px;float:left;" size="large">暂不授权</Button></div>
                </div>
            </div>
        </Modal>
        <!--  <Printer ref="myprinter" /> -->
    </div>
</template>
<script>
// import UserReg from '../components/userlogin/reg.vue'
// import Printer from '../components/common/doc/printer.vue'
import bindDistributor from '../components/userlogin/bind-distributor.vue'
import mypromo from '../components/userlogin/mypromocode.vue'
import mycustomer from '../components/userlogin/mycustomer.vue'
import wechatbind from '../components/userlogin/wechat_bind.vue'
import wechatreg from '../components/userlogin/wechat_reg.vue'
import wechatLogin from '../components/userlogin/wechat_login.vue'
import wechatLoginCustom from '../components/userlogin/wechat_login_custom.vue'
import SmsCodeEditWXAccount from '../components/userlogin/wxeditacc-sms-check.vue'
import UserReg from '../components/userlogin/reg-sms-check.vue'
import UserReg2 from '../components/userlogin/reg2.vue'
import UserSetPwd from '../components/userlogin/reg-set-password.vue'
import UserPassword from '../components/userlogin/getpasswd.vue'
import UserResetWXToken from '../components/userlogin/reset-wxtoken-getsmscode.vue'
import GetPwdSubmit from '../components/userlogin/getpwdsubmit.vue'
import EditPwdSubmit from '../components/userlogin/editpwd.vue'
import UserLogin from '../components/userlogin/login.vue'
import SmsLogin from '../components/userlogin/smslogin.vue'
import UserInfo from '../components/userlogin/userinfo.vue'
import ManagePwd from '../components/userlogin/manage/managepwd.vue'
import UserLoginMenu from '../components/userlogin/dropdownmenu.vue'
import DocManage from '../components/userlogin/multiScreenMenu.vue'
import UserVipPackagePay from '../components/user_store/vippackages_renew.vue'
import UserProductPay from '../components/user_store/product_renew.vue'
import MyVip from '../components/user_store/myvip.vue'
import Agreement from '../components/agreement.vue'
import Statement from '../components/stateMent.vue'
import ChangePhone from '../components/userlogin/change-phone.vue'
import ChangePhoneSubmit from '../components/userlogin/change-phone-submit.vue'
import BindPhone from '../components/userlogin/bind-phone.vue'

import { mapActions, mapGetters } from 'vuex'
import { addFavorite } from '../components/common/add-favorite'
import ConstJson from "../api/common/constjson.js"
import RegJson from "../api/security/reg.js"
import eventBus from "../components/common/event_bus.js"
import store from '../store/'
let constJ = new ConstJson()
let regJ = new RegJson()

// web-tts
const utterance = new SpeechSynthesisUtterance()
utterance.rate = 1
// utterance.volume = '1'; // 声音的音量，区间范围是0到1，默认是1。
// utterance.rate = 1;// 设置播放语速，范围：0.1 - 10之间    正常为1倍播放
// utterance.pitch = '0'; // 表示说话的音高，数值，范围从0（最小）到2（最大）。默认值为1。
// utterance.lang = 'zh-cn'; // 使用的语言，字符串， 例如："zh-cn"
// utterance.voiceURI = 'Google 普通话（中国大陆）';



let boundary_index = 0
let currentPlayingName = ''
utterance.onpause = (event) => {
    console.log('暂停');
}
utterance.onerror = (event) => {
    console.log('onerror');
    console.log(event);
}
utterance.onresume = (event) => {
    console.log('恢复');
}

utterance.onboundary = (event) => {
    console.log('边界值：' + event.charIndex);
    boundary_index = event.charIndex
}
// const synth = window.speechSynthesis;


//audio
const audiotts = new Audio()
audiotts.src = ""

audiotts.onended = (event) => {
    console.log("Video stopped either because  it was over")
    eventBus.$emit('reset_player_on_finished', currentPlayingName)
    // this.resetPlayer(currentPlayingName)
}
audiotts.onerror = (event) => {
    console.log('audiotts onerror');
    console.log(event);
}
audiotts.onplaying = (event) => {
    console.log('audiotts is playing');
    console.log(event);
    console.log('the audio length:' + audiotts.duration)
}

// audiotts.oncanplaythrough=(event)=>{
//     console.log('audiotts is oncanplaythrough');
//     console.log(event);
// }

// audiotts.onprogress=(event)=>{
//     console.log('audiotts is onprogress');
//     console.log(event);
// }


export default {
    name: 'TopHeader',
    inject: ["getSliders", "removeAllSliders"],
    data() {
        return {
            mycustomer_total:0,
            islogoshow: store.state.user.isjxt,
            tempStrDocId: '', //通过邮件发送政策文件时使用
            user_email: '', //通过邮件发送政策文件时使用
            modal12: false, //通过邮件发送政策文件时使用
            modal11: false,
            modalPrinter: false, //打印
            loginSrc: '', //1=打开保护文件
            regTabValue: '1',
            isWxRegGetTelNum: false, //微信注册获取验证码
            loginTabValue: '1',
            modalBindWechat: false, //关联微信
            modalResetWxToken: false, //重置微信
            isShowBindWxFooter: false,
            isShowRegFooter: true,
            isShowLoginFooter: true,
            modalEditAccountSmsCode: false, //修改账号获取验证码
            isDisablePay: false,
            modalNoPermissionContent: '',
            storeTabIndex: 1,
            modalNoPermission: false, //提示没有权限，去商城购买
            showServerMessage: '',
            showServerOtherMessage: '',
            modalShowOtherNotice: false, //显示升级到专业版的提示信息
            modalCheckStatus: false,
            modalVipPay: false,
            modalCheckPermission: false,
            isMsgShow: false,
            visible: false,
            res: "",
            modal1: false,
            modalLogin: false,
            modalPwd: false,
            modalEditPwd: false,
            modalSetPwd: false,
            modalPwdSubmit: false,
            modalPages: false,
            modalUserInfo: false,
            modalManagePwd: false,
            modalPay: false,
            modalMyVip: false,
            modalAgreement: false,
            modalStateMent: false,
            modalChangePhone: false,
            modalChangePhoneSubmit: false,
            modalBindPhone: false,
            modalPromo: false,
            modalCustomer:false,
            modalBindDistriButor: false,
            modalRiskDetection:false,
            buttonSize: 'default',
            buttonColor: '#808695',
            showLoginBtn: true,
            showLoginUserMenu: false,
            showMultiScreenBtn: false,
            showRequestTrial: true,
            regdata: Object,
            wxregtoken: Object,
            forgetpwddata: Object,
            changePhoneValidData: Object,
            backUrl: "",
            //home: "/main/searchengine/search",
            home: "/main/localsearch/localindex",
            isLoginButtonDisable: false,
            loginType: 1, //1=账号登录,2=短信登录
            loginMsg: '您的账号未购买账号等级或账号处于冻结期',
            print_progress: 0,
        }
    },
    // beforeDestroy() {
    //     eventBus.$off('user-login')
    //     eventBus.$off('user-renewal')
    //     eventBus.$off('user-vipboard')
    // },
    mounted() {
        // if (store.state.user.mobileNum !== '') {
        //   this.showLoginBtn = false;
        //   this.buttonSize = "small";
        //   this.buttonColor = "#2db7f5"
        //   this.showLoginUserMenu = true;
        // }

        eventBus.$on('printer', (val, row) => {
            // this.printer(val, row)
            this.printer(val, row)
        })

        //事件来源:resultTag.vue,api.request.js
        eventBus.$on('user-login', (login, loginsrc) => {
            console.log("user-login...")
            //this.loginSrc=loginsrc
            //根据登录来源设定登录成功后需要处理的业务
            this.loginSrc = loginsrc ? loginsrc : ''
            console.log("loginsrc===>" + this.loginSrc)
            //console.log('user-login=====>'+login,this.loginSrc)
            this.showlogin()

        })
        eventBus.$on('user-logoff', () => {
            //console.log("user-login...")
            this.userLogout()
        })
        eventBus.$on('update-loginState', (isWxMember) => {
            // this.showLoginBtn = false;
            // this.buttonSize = "small";
            // this.buttonColor = "#2db7f5"
            // this.showLoginUserMenu = true;

            //根据isWxMember弹出修改账号确认框
            this.login_ok()
        })
        //监听续费
        eventBus.$on('user-renewal', (row) => {
            console.log("go renewal...")
            this.showpaymodal(row)

        })
        //vip续费
        eventBus.$on('user-vip-renewal', (row) => {
            console.log("go user-vip-renewal...")
            this.showvippaymodal(row)

        })

        eventBus.$on('user-vipboard', () => {
            console.log('show vipboard')
            this.showvipmodal()
        })

        eventBus.$on('user-nopermission-board', (content, tabindex) => {
            console.log('show user-nopermission-board')
            this.showModalNoPermission(content, tabindex)
        })

        eventBus.$on('user-bind-wechat', (content) => {
            console.log('ser-bind-wechat')
            this.showBindWechat()
        })
        eventBus.$on('user-bind-mobile', (content) => {
            console.log('show-bind-mobile')
            this.showbp()
        })

        eventBus.$on('user-flashToken', () => {
            console.log('user-refreshToken==>')
            this.reloadUser()
        })
        //刷新登录数据获取会员等级信息-更新登录状态
        eventBus.$on('user-reload-update', () => {
            console.log('user-refreshToken==>')
            this.reloadAndUpdateUser()
        })
        eventBus.$on('user-wexin-reg', (wxtoken) => {
            console.log('user-wexin-regV2==>')
            this.checkWxTokenIsReged(wxtoken)

        })

        //web-tts
        eventBus.$on('tts-play', (txt, name, row) => {
            console.log('tts-play==>')
            this.playText(txt, name, row)
        })
        eventBus.$on('tts-stop', (name) => {
            console.log('tts-stop==>')
            this.stopText(name)
        })
        eventBus.$on('tts-stop-force', (name) => {
            console.log('tts-stop-force==>')
            this.stopTextForce()
        })
        eventBus.$on('tts-pause', (name) => {
            console.log('tts-pause==>')
            this.pauseText(name)
        })


        utterance.addEventListener('error', e => {
            console.log(e)
        })
        utterance.addEventListener('end', () => {
            console.log('the voices name of ' + currentPlayingName + ' is end...')
        })


        //audio
        eventBus.$on('audiotts-play', (name, src, row) => {
            console.log('audiotts-stop==>')
            this.audioPlay(name, src)
        })
        eventBus.$on('audiotts-pause', (name) => {
            console.log('audiotts-pause==>')
            this.audioPause(name)
        })
        eventBus.$on('audiotts-stop', (name) => {
            console.log('audiotts-stop==>')
            this.audioStop(name)
        })
        eventBus.$on('audiotts-stop-force', () => {
            console.log('audiotts-stop-force==>')
            this.audioStopForce()
        })
        eventBus.$on('send-mail-with-file', (trow) => {
            console.log(trow)
            console.log('send-mail-with-file==>')
            console.log(this.user_email)
            if (trow) {
                if (trow.fileid) {
                    //strid = row.fileid
                    this.tempStrDocId = trow.fileid
                } else if (trow.strdocid) {
                    //strid = row.strdocid
                    this.tempStrDocId = trow.strdocid
                }
            } else {
                console.log('tempStrDocId:' + this.tempStrDocId)
            }

            this.modal12 = true
            this.user_email = store.state.user.email
        })
        eventBus.$on('lunch-guide', () => {
            console.log('lunch-guide==>')
            //加载引导教学
            var routeName = this.$route.name;
            console.log('login success,current route is '+routeName)
            this.$nextTick(function() {
                if(store.state.user.numberofguide > 0 && routeName=='localindex' && store.state.user.accounttype !== 0){
                    this.initStep()
                    store.state.user.numberofguide--
                }
            })
            
        })

        eventBus.$on('authorRDLogin', (name) => {
            console.log('author riskdetection login')
            this.modalRiskDetection=true
        })
        // eventBus.$on('on-link-open', (id) => {
        //     console.log('on-link-open:' + id)
        //     this.tempStrDocId = id
        // })

        //voiceschanged
        // speechSynthesis.addEventListener('voiceschanged', e => {
        //     console.log('addEventListener...')
        //     console.log(e)
        // })


        //web-tts event 获取播放进度索引
        // utterance.addEventListener('boundary', e => {
        //     currentCharacter = e.charIndex
        //     console.log('boundary==>',currentCharacter)
        // })



        // eventBus.$on('user-bind-wechat', () => {
        //     console.log("user-bind-wechat===>")
        //     this.showBindWechat()

        // })

        // this.load();
    },
    computed: {
        ...mapGetters(['getUserId', 'getAccountType'])
    },
    // 移除事件句柄
    beforeDestroy() {
        console.log('remove eventBus')
        eventBus.$off('printer')
        eventBus.$off('user-login')
        eventBus.$off('update-loginState')
        eventBus.$off('user-vipboard')
        eventBus.$off('user-renewal')
        eventBus.$off('user-vip-renewal')
        eventBus.$off('user-nopermission-board')
        eventBus.$off('user-flashToken')
        eventBus.$off('user-logoff')
        eventBus.$off('user-reload-update')
        eventBus.$off('user-bind-wechat')
        eventBus.$off('user-bind-mobile')
        eventBus.$off('user-wexin-reg')

        // tts
        eventBus.$off('tts-play')
        eventBus.$off('tts-stop')
        eventBus.$off('tts-pause')
        eventBus.$off('tts-stop-force')

        //audio
        eventBus.$off('audiotts-play')
        eventBus.$off('audiotts-stop')
        eventBus.$off('audiotts-pause')
        eventBus.$off('audiotts-stop-force')
        eventBus.$off('send-mail-with-file')
        eventBus.$off('lunch-guide')
        eventBus.$off('authorRDLogin')
        //eventBus.$off('user-bind-wechat')
        //document.removeEventListener('click', this.myFunc)
    },
    created() {
        //document.addEventListener('click', this.myFunc)
        //this.upload()
        console.log('header.created...')
        // console.log(store.getters.sta)
        //普通用户登录或企业用户登录,隐藏申请试用菜单
        // console.log("getUserType:"+this.getUserType)
        // if (this.getUserType !== "" && this.getUserId !== "" && this.getUserType !== "temp") {
        //     this.showRequestTrial=false
        // }

        // this.showLoginBtn = false;
        // this.buttonSize = "small";
        // this.buttonColor = "#2db7f5"
        // this.showLoginUserMenu = true;


        if (sessionStorage.st !== undefined && store.state.user.userId !== "") {
            this.showLoginBtn = false;
            this.buttonSize = "small";
            this.buttonColor = "#2db7f5"
            this.showLoginUserMenu = true;
        }
        if (this.checkUserLogin()) {
            this.getProducts()

            //控制下拉
            //this.$refs.myUserMenu.showAuthority()
        }

        //初始化tts
        this.stopTextForce()
        //加载语音
        //this.audioPlay()

    },
    methods: {
        // getWXUrl() {
        //     let po = {
        //         http_redirct:'',
        //     }
        //     console.log('getWXUrl======================>')
        //     constJ.reqWXUrl(po).then(res => {
        //         console.log(res)
        //     })
        // }, 
        onCustomers_loading_over(v){
            this.mycustomer_total=v
        },
        initStep() {
            this.$intro().setOptions({
            prevLabel:"返回",
            nextLabel:"下一步",
            doneLabel:"结束",
            skipLabel:"跳过",
            overlayOpacity:"0.7",
            showStepNumbers:true,
            stepNumbersOfLabel:"/",
            showBullets:false,
            showProgress:false,
            exitOnOverlayClick:false,
            showProgress:true,
            // tooltipClass:"customTooltip",
            steps: [{
                  intro: '<div style="text-align:center;font-size:15px;">欢迎使用众智云擎法规查询引导</div>'
              },
              {
                element: document.querySelector('.step1'),
                intro: '<div style="text-align:center;">在当前区域下进行关键字检索，可通过<b style="color:yellow"> 文件效力选择器 </b>和<b style="color:yellow"> 时间范围选择器 </b>缩小检索结果</div>',
                position: 'right'
              },
              {
                element: document.querySelector('.steptree'),
                intro: '<div style="text-align:center;">当前区域为 <b style="color:yellow">文件分类树 </b><br />文件分类树可以缩小检索结果<br /> (包含10个大类,585个小类)<br /> 点击箭头 <b style="color:gray"> > </b> 可展开子类</div>',
                position: 'right'
              },{
                element: document.querySelector('.stepcity'),
                intro: '<div style="text-align:center;">选择 <b style="color:yellow">政策法规区域</b>（省 / 市）<br />切换显示对应省 / 市的政策法规检索结果</div>',
                position: 'right'
              },
              {
                element: document.querySelector('.ivu-tabs-nav-scroll'),
                intro: '<div style="text-align:center;">点击此<b style="color:yellow"> 法规层级 </b> 可切换显示本次检索的区域政策</div>',
                position: 'left'
              },
              {
                element: document.querySelector('.step2'),
                intro: '<div style="text-align:center;">当前区域为（中央 / 省 / 市）下的 <br /> <b style="color:yellow">检索结果</b> 政策法规列表</div>',
                position: 'left'
              },{
                element: document.querySelector('.step3'),
                intro: '<div style="text-align:center;">此区域操作按钮可以将检索结果 <br /><b style="color:yellow"> 一键上传 </b>或 <b style="color:yellow"> 选择上传 </b>至智慧云端</div>',
                position: 'right'
              },{
                element: document.querySelector('#dropMenu'),
                intro: '<div style="text-align:center;">点击“用户ID”展开<br /><b style="color:yellow">账号设置</b>,账号设置包含<b style="color:lightblue">账号中心、重置密码、更换手机、关联微信、修改密码</b>等功能',
                position: 'right'
              }]
            }).start();
        },
        sendMail() {
            try {
                let args = {
                    strdocid: this.tempStrDocId,
                    email: this.user_email,
                }
                constJ.reqSendMailWithFile(args).then(res => {
                    console.log(res)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            this.$Message.success('文件已发送至邮箱');
                            console.log("发送邮件成功");
                            store.commit('setEmail', this.user_email)
                            this.modal12 = false
                            this.tempStrDocId = ''
                        } else {
                            this.$Message.warning(res.rltdesc);
                        }
                    } else {
                        this.$Message.warning(res.rtndesc);
                    }
                })
            } catch (e) {
                console.log("发送邮件异常");
                console.log(e);
            }
        },
        audioPlay(name, url) {
            console.log(name, url, audiotts.paused)
            if (currentPlayingName != name) {
                this.resetPlayer(name)
                audiotts.src = url
                audiotts.play()
                currentPlayingName = name
            } else {
                if (audiotts.paused) {
                    audiotts.play()
                } else {
                    this.audioPause()
                }
            }
        },
        audioPause(name) {
            if (currentPlayingName == name) {
                audiotts.pause()
            }
        },
        audioStop(name) {
            if (currentPlayingName == name) {
                audiotts.load()
            }
        },
        audioStopForce() {
            audiotts.load()
        },
        handleSpinCustom() {
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                size: 20,
                            }
                        }),
                        h('div', {
                            style: {
                                fontSize: "18px",
                                fontFamily: "Source Han Sans CN",

                            }
                        }, "正在加载打印数据")
                    ])
                }
            });
            ////控制客服图标隐藏
            // document.getElementById('ECHAT_mini_icon').style.display = "none"
        },
        printer1(strHtml, row) {
            console.log(row)
            this.print_progress = 0
            this.modal11 = true
            let doc = this.$refs.myprinter1
            console.log(doc)
            doc.innerHTML = ''
            doc.innerHTML = strHtml
            doc.style.display = "block";
            doc.style.width = "100%";
            doc.id = "temp01"



            //水印
            let canvas = document.createElement('canvas');
            canvas.width = 120;
            canvas.height = 80;
            canvas.style.border = '1px solid red';
            let ctx = canvas.getContext('2d');
            ctx.rotate(-30 * Math.PI / 180);
            ctx.font = '15px Vedana';
            ctx.fillStyle = '#444'
            ctx.fillText('众智云擎', 10, 70);

            let div = document.createElement('div');
            div.style.pointerEvents = 'none';
            div.style.top = '0px';
            div.style.left = '0px';
            div.style.opacity = '0.2';
            div.style.position = 'fixed';
            div.style.width = document.documentElement.clientWidth + 'px';
            div.style.height = document.documentElement.clientHeight + 'px';
            div.style.background = 'url(' + canvas.toDataURL('image/png') + ') left top repeat';
            div.style.setProperty('-webkit-print-color-adjust', 'exact')
            div.style.setProperty('-moz-print-color-adjust', 'exact')
            div.style.setProperty('-ms-print-color-adjust', 'exact')
            div.style.setProperty('print-color-adjust', 'exact')
            if (row && !row.wsw) {
                doc.appendChild(div)
            }


            printJS({
                printable: 'temp01',
                type: 'html',
                targetStyles: ['*'], //继承页面要打印元素原有的css属性
                scanStyles: true, //不适用默认样式
                style: `@page {margin:0 10mm}`,
                onLoadingStart: () => {
                    console.log("loading start");
                    this.print_progress++;
                },
                onLoadingEnd: () => {
                    this.print_progress++
                    this.$Spin.hide()
                    console.log("process is: " + process + ",load end")
                    //this.uploadPrinterinfo(row,process)
                },
            })
            this.modal11 = false
            //控制客服图标显示
            // document.getElementById('ECHAT_mini_icon').style.display = "block"
            console.log("TimeOut Executado");
            this.$Spin.hide()
            this.uploadPrinterinfo(row)


        },
        printer(strHtml, row) {
            this.handleSpinCustom()
            setTimeout(() => {
                this.printer1(strHtml, row)
            }, 3000)
        },
        uploadPrinterinfo(row) {
            console.log(row)
            let strid = ""
            if (row.fileid) {
                strid = row.fileid
            } else if (row.strdocid) {
                strid = row.strdocid
            }
            console.log('print strid:' + strid)
            constJ.reqPrinter(strid).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        console.log("已上报打印信息");
                        if (this.print_progress == 2) {
                            //this.$Message.success('打印机调用成功');
                            console.log("process is: " + this.print_progress + ",load success")
                        } else {
                            this.$Message.error('打印机调用异常，请下载后打印');
                            console.log("process is: " + this.print_progress + ",load failure")
                        }
                        return
                    } else {
                        console.log(res.rltdesc);
                        return
                    }
                } else {
                    console.log(res.rtndesc);
                    return
                }
            })
        },
        playText(text, name, row) {
            console.log(row)
            if ('speechSynthesis' in window) {
                console.log('Browser support')
            } else {
                console.log('Browser not support')
            }
            console.log(currentPlayingName + '|' + name)
            // const voices = speechSynthesis.getVoices();
            // console.log(voices)
            console.log('speechSynthesis.paused:' + speechSynthesis.paused)
            console.log('speechSynthesis.speaking:' + speechSynthesis.speaking)
            console.log('speechSynthesis.pending:' + speechSynthesis.pending)
            if (currentPlayingName != name) {
                this.stopTextForce()
                //同步播放设置状态
                this.resetPlayer(name)
                currentPlayingName = name
            }
            console.log(utterance)
            //续播
            if (speechSynthesis.paused && speechSynthesis.speaking) {
                console.log('speechSynthesis.resume()--')
                console.log('progress boundary_index:' + boundary_index)
                this.stopTextForce()
                utterance.text = utterance.text.substring(boundary_index)
                speechSynthesis.speak(utterance)
                // return speechSynthesis.resume()
            }

            if (speechSynthesis.speaking) return
            utterance.text = text
            console.log('speechSynthesis.speaking--')
            console.log('speechSynthesis.speaking:' + speechSynthesis.speaking)
            speechSynthesis.speak(utterance)
            try {
                constJ.reqGetTTSStream(row.strdocid).then(res => {
                    console.log(res)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            //this.$Message.success('获取tts成功');
                            console.log("获取tts文件流成功");
                        } else {
                            this.$Message.warning(res.rltdesc);
                        }
                    } else {
                        this.$Message.warning(res.rtndesc);
                    }
                })
            } catch (e) {
                console.log("获取tts文件流异常");
                console.log(e);
            }
        },

        pauseText(name) {
            console.log('pause:' + currentPlayingName + '|' + name)
            if (currentPlayingName == name) {
                if (speechSynthesis.speaking) {
                    speechSynthesis.pause()
                }
                // console.log('speechSynthesis.speaking-->pause:'+speechSynthesis.speaking)
                // if (speechSynthesis.speaking){
                //     console.log('强制关闭当前语音---')
                //     this.stopTextForce()
                // }
            }

        },
        stopTextForce() {
            speechSynthesis.resume()
            speechSynthesis.cancel()
        },
        stopText(name) {
            console.log('stop:' + currentPlayingName + '|' + name)
            if (currentPlayingName == name) {
                speechSynthesis.resume()
                speechSynthesis.cancel()
            }

        },
        resetPlayer(id) {
            eventBus.$emit('reset_player', id)
        },

        //切换到登录
        switchLogin() {
            this.clear()
            this.modal1 = false
            this.modalLogin = true
        },
        bindDistri(state) {
            this.modalPromo = false
            this.modalBindDistriButor = true
            this.$nextTick(() => {
                if (state) {
                    this.$refs.bindmydistributor.isBind = true
                } else {
                    this.$refs.bindmydistributor.isBind = false
                }
            })

        },
        wxRegTokenClear() {
            this.wxregtoken = null
            console.log("wxregtoken===>" + this.wxregtoken)
        },
        refreshMain() {
            let routername = this.$router.history.current.name
            console.log('routername=====>' + routername)
            if (routername !== 'localindex') {
                this.$router.push({ name: 'localsearch' })
            } else {
                eventBus.$emit("user-refresh-newlist")
            }

        },
        reloadAndUpdateUser() {
            //let routername = this.$router.history.current.name
            // if (routername !== 'userstore') {
            // }
            console.log('reloadUser====>')
            this.flashToken().then(res => {
                Promise.all([this.getProducts()]).then(res => {
                    let state = this.sta
                    this.checkAccountStatus(state)
                    this.update_login_state()
                });
            }).catch(err => {
                console.log(err)
            })
        },
        reloadUser() {
            //let routername = this.$router.history.current.name
            // if (routername !== 'userstore') {
            // }
            console.log('reloadUser====>')
            this.flashToken().then(res => {
                Promise.all([this.getProducts()]).then(res => {
                    let state = this.sta
                    this.checkAccountStatus(state)
                    this.update_login_state()
                });
            }).catch(err => {
                console.log(err)
            })
        },
        renewal_reloadUser() {
            console.log('reloadUser====>')
            this.flashToken().then(res => {
                Promise.all([this.getProducts(true)]).then(res => {
                    let state = this.sta
                    this.checkAccountStatus(state)
                    this.update_login_state()
                });
            }).catch(err => {
                console.log(err)
            })
        },

        //微信登陆时检测
        //微信已注册且购买了会员等级
        //前三天提示:"系统检测到您尚未修改账号，请修改账号"
        //微信注册成功并返回已购标识，前三天提示:"系统检测到您尚未修改账号，请修改账号"
        checkIsWxMember(po) {
            this.$Modal.confirm({
                title: '提示',
                content: '<p>系统检测到您尚未修改账号，请修改账号？</p>',
                cancelText: "关闭",
                okText: '确认修改',
                onOk: () => {
                    //拉起修改账号
                    this.showsmswxaccount()
                },
                onCancel: () => {
                    return
                }
            });
        },

        disablePayment(value) {
            this.isDisablePay = value
        },
        showBindWechat() {
            this.modalBindWechat = true
            //this.$refs.mywechatbind.wexinLogin()
            this.$refs.mywechatbind2.wexinLogin()
        },
        showModalNoPermission(content, tabindex) {
            this.modalNoPermission = true
            this.modalNoPermissionContent = content
            this.storeTabIndex = tabindex
        },
        shutDownNoPermissionModal() {
            this.modalNoPermission = false
        },
        setOtherNoticeRead() {
            //this.modalShowOtherNotice = false
            var po = {
                state: 'upBaseProductNotice', //场景（"upBaseProductNotice":基础包免费升级提示）
            }

            constJ.reqSetNoticeRead(po).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success('感谢您的支持');
                        this.modalShowOtherNotice = false
                    } else {
                        this.$Message.warning(res.rltdesc);
                    }
                } else {
                    this.$Message.warning(res.rtndesc);
                }
            })

        },
        shutDownStatusModal() {
            this.modalCheckStatus = false
        },
        reloadmyvip() {
            this.modalVipPay = false
            console.log('重载我的已购vip产品列表数据==>')
            //this.getProducts()
            //重载用户权限和产品列表
            this.reloadUser()

            //重载我的账号
            //this.$refs.myVipPage.show()
        },
        reloadmyproduct() {
            this.modalPay = false
            console.log('重载我的已购产品列表数据==>')
            this.renewal_reloadUser()

            //this.getProducts(true)

            //拉起续费vip包
            //this.showvippaymodal()


            //重载我的账号
            //this.$refs.myVipPage.show()

        },
        logoff() {
            this.userLogout()
        },
        goStore3() {
            this.modalNoPermission = false
            this.removeAllSliders()
            if (this.storeTabIndex === 1) {
                this.$router.push({ name: 'userstore', params: { tabindex: 'name1' } })
            } else {
                this.$router.push({ name: 'userstore', params: { tabindex: 'name2' } })
            }

        },
        goStore2() {
            this.modalCheckStatus = false
            this.removeAllSliders()
            this.$router.push({ name: 'userstore', params: { tabindex: 'name1' } })
        },
        goStore() {
            this.modalCheckPermission = false
            this.removeAllSliders()
            this.$router.push({ name: 'userstore', params: { tabindex: 'name1' } })
        },
        checkUserLogin() {
            // console.log(store.state.user.userId)
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },
        myFunc(event) {
            console.log(event)
            this.handleClose()
        },
        switchMessageBoard() {
            this.visible = !this.visible
        },
        handleOpen() {
            this.visible = true;
        },
        handleClose() {
            console.log('close------->')
            this.visible = false;
        },
        //绑定手机号码
        sumitBpInfo(value) {
            console.log(value)
            let update_data = {
                mobile: value.tel,
                smscode: value.sms
            }
            regJ.reqMobileBind(update_data).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success('手机号码绑定成功');
                        //更新数据
                        let u = JSON.parse(sessionStorage.getItem('st'))
                        u.mobileNum = update_data.mobile
                        //更新sessionStorage
                        store.commit('setLoginUser', u)
                        store.state.user.mobileNum = update_data.mobile
                        this.modalBindPhone = false
                    } else {
                        this.$Message.error('绑定手机号码失败，失败原因:' + res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.error('绑定手机号码失败，失败原因:' + res.rtndesc)
                    return
                }
            })
        },
        sumitCpsInfo(value) {
            //提交到后端验证

            regJ.reqRegCheckSmsCode(value.tel, value.sms, value.smstypecode).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //验证码验证成功,提交到修改接口更新用户数据
                        let update_data = {}
                        update_data.mobilenum_old = this.changePhoneValidData.tel
                        update_data.smscode_old = this.changePhoneValidData.sms
                        update_data.mobilenum_new = value.tel
                        update_data.smscode_new = value.sms
                        console.log('请求更新手机号码===>')
                        regJ.reqMobileUpdate(update_data).then(res => {
                            console.log(res)
                            if (res.rtncode === 1) {
                                if (res.rltcode === 1) {
                                    this.$Message.success('手机号码更换成功');
                                    //更新数据
                                    let u = JSON.parse(sessionStorage.getItem('st'))
                                    u.mobileNum = update_data.mobilenum_new
                                    //更新sessionStorage
                                    store.commit('setLoginUser', u)
                                    store.state.user.mobileNum = update_data.mobilenum_new
                                    this.modalChangePhoneSubmit = false

                                } else {
                                    this.$Message.error('更换手机号码失败，失败原因:' + res.rltdesc)
                                    return
                                }
                            } else {
                                this.$Message.error('更换手机号码失败，失败原因:' + res.rtndesc)
                                return
                            }
                        })


                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }

            })
        },
        sumitCpInfo(value) {
            //提交到后端验证
            this.changePhoneValidData = value
            regJ.reqRegCheckSmsCode(value.tel, value.sms, value.smstypecode).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //验证码验证成功,
                        this.modalChangePhone = false;
                        this.modalChangePhoneSubmit = true
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }

            })

        },
        upload() {
            if (store.state.user.localinfo === undefined ||
                store.state.user.localinfo === null ||
                store.state.user.localinfo.status !== "success") {
                return;
            }
            let src = this.$baseConfig.ipApi
            let uid = store.state.user.userId
            let uguid = store.state.user.userGuid
            let postion = JSON.stringify(store.state.user.localinfo)
            console.log(src, uid, uguid, postion)
            constJ.upLoadInfo(src, uid, uguid, postion).then(res => {
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //console.log("uploadinfo success")
                    } else {
                        console.log(res.rltdesc)
                        return
                    }
                } else {
                    console.log(res.rtndesc)
                    return
                }
            }).catch(err => {
                console.log(err)
                return
            })
        },
        // reload() {
        //   this.isRouterAlive = false
        //   this.$nextTick(() => (this.isRouterAlive = true))
        // },
        showStateMent() {
            this.modalStateMent = true
        },
        closeStateMent() {
            this.modalStateMent = false
        },
        closeAgreement() {
            this.modalAgreement = false
            this.$refs.userregsetpwd.setAgreement()
        },
        showAgreement() {
            this.modalAgreement = true
        },
        tabsClick(name) {

            this.loginType = Number(name)
            console.log("loginType:" + this.loginType)
            if (name === "3") {
                this.isShowLoginFooter = false
                this.$refs.mywechatlogin.wexinLogin()
            } else if (name === "4") {
                this.isShowLoginFooter = false
                this.$refs.mywechatlogin2.wexinLogin()
            } else {
                this.isShowLoginFooter = true
                this.$refs.mywechatlogin2.isQueryWXState = false
                this.$refs.mywechatlogin2.closeQRCode()
            }
        },
        tabsClickReg(name) {
            //this.loginType = Number(name)
            //console.log("regType:" + this.loginType)
            if (name === "2") {
                this.isShowRegFooter = false
                this.$refs.mywechatreg.wexinLogin()
            }
            if (name === "3") {
                //如果是显示注册二维码
                if (!this.isWxRegGetTelNum) {
                    this.isShowRegFooter = false
                    this.$refs.mywechatreg2.wexinLogin()
                }

            } else {
                this.isShowRegFooter = true
                this.$refs.mywechatreg2.isQueryWXState = false
                this.$refs.mywechatreg2.closeQRCode()
            }
        },
        handle_tmpLogin() {
            //console.log(this.sta.isLogin)
            this.handleTempLogin()
                .then(res => {})
                .catch(err => {
                    console.log(err)
                })

        },
        //注册
        ok() {
            if (!this.isWxRegGetTelNum) {
                this.$refs.userinfo.handleSubmit('formCustom');
            } else {
                this.$refs.userinfowxreg.handleSubmit('formCustom');
            }
        },
        cancel() {
            this.regTabValue = "1"
            this.isShowRegFooter = true
            //移出定时器
            if (this.$refs.mywechatreg2) {
                this.$refs.mywechatreg2.isQueryWXState = false
                this.$refs.mywechatreg2.closeQRCode()
            }
            this.modal1 = false;
            this.clear()
            this.loginCannel()

            //this.$Message.info('Clicked cancel');
        },
        //检查验证码
        reg_ok(value) {
            //console.log("ok...")
            this.regdata = value
            regJ.reqRegCheckSmsCode(value.tel, value.sms, value.smstypecode).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //验证码验证成功,开始注册
                        if (value.smstypecode === 5) {
                            this.modalEditAccountSmsCode = false
                        } else if (value.smstypecode === 7) {
                            this.modalEditAccountSmsCode = false
                        } else {
                            this.modal1 = false;
                        }
                        this.modalSetPwd = true;
                        this.$nextTick(() => (this.$refs.userreg2.formCustom.unittel = value.tel))
                        //this.$refs.userreg2.formCustom.unittel=value.tel
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }

            })

        },
        //账号修改-微信合并账号-检查验证码并合并
        wxMergeChecksms(value) {
            console.log(value)
            this.regdata = value
            regJ.reqRegCheckSmsCode(value.tel, value.sms, value.smstypecode).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //验证码验证成功,开始注册
                        this.modalEditAccountSmsCode = false
                        //合并
                        //this.wxBindUser(value)
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }

            })

        },
        //账号修改-微信合并账号
        wxBindUser(da) {
            var po = {
                mobilenum: da.tel,
                smscode: da.sms,
                reqidentity: da.reqidentity, //da.smstypecode,//传空
            }

            constJ.reqWXBindUserId(po).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success('账号合并成功');
                        this.modalEditAccountSmsCode = false
                    } else {
                        this.$Message.warning(res.rltdesc);
                    }
                } else {
                    this.$Message.warning(res.rtndesc);
                }
            })
        },
        //账号修改-微信创建账号
        wxCreateUserid(reginfo) {
            var reginfo = {
                //userId: this.regdata.tel,
                mobilenum: this.regdata.tel,
                userid: reginfo.account,
                password: reginfo.passwd,
                reqidentity: this.regdata.reqidentity,
                smscode: this.regdata.sms,
                realname: '',
                remark: ''
            }

            constJ.reqWXCreateUserId(reginfo).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.modalSetPwd = false;
                        this.$Message.success('修改账号成功');
                        this.reloadUser()

                    } else if (res.rltcode === -1021) {
                        //验证码无效
                        this.modalSetPwd = false;
                        //重输验证码
                        //this.createAcc()
                        this.clear()
                        this.modalEditAccountSmsCode = true
                        //清空验证码
                        //this.$refs.userinfo.cleanSmsCode()
                        this.$Message.error(res.rltdesc);
                        return
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            })


        },

        //团购用户，微信注册用户修改账号
        editUserId(reginfo) {
            var po = {
                smscode: this.regdata.sms,
                userid: reginfo.account,
                password: reginfo.passwd
            }
            constJ.reqEditUserId(po).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.modalSetPwd = false;
                        this.$Message.success('修改账号操作成功');
                        this.reloadUser()
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            })
        },

        //设置密码并注册账号
        regSetPwdOk(reginfo) {
            // console.log(pwd)
            // console.log(this.regdata)
            //userId, password,tempuserguid,smscode, unitname
            console.log(this.regdata)
            //先处理修改账号填写账号密码的场景
            if (this.regdata.smstypecode === 5) {
                this.wxCreateUserid(reginfo)
                return
            }
            //团购用户购买成功以及微信账号购买成功后修改账号
            if (this.regdata.smstypecode === 7) {
                console.log('购用户购买成功以及微信账号购买成功后修改账号==>')
                this.editUserId(reginfo)
                return
            }


            //构建正常注册参数(所属地域)
            let location = {}
            if (reginfo.locationcode && reginfo.locationcode.length > 0) {
                location.province = reginfo.locationcode[0] ? reginfo.locationcode[0].value : '000000'
                location.city = reginfo.locationcode[1] ? reginfo.locationcode[1].value : '000000'
            } else {
                location.province = '000000'
                location.city = '000000'
            }

            //正常注册填写账号密码的场景
            var reginfo = {
                //userId: this.regdata.tel,
                userid: reginfo.account,
                mobilenum: this.regdata.tel,
                tempuserguid: store.state.user.userGuid,
                password: reginfo.passwd,
                smscode: this.regdata.sms,
                unitname: reginfo.unitname,
                unittel: reginfo.unittel,
                industrycode: reginfo.industrycode,
                province: location.province,
                city: location.city,
            }

            //先处理微信扫码注册，并退出逻辑
            if (this.wxregtoken && this.wxregtoken.state && this.wxregtoken.code) {
                console.log('进入扫码注册===>')
                let reginfo2 = reginfo
                reginfo2.code = this.wxregtoken.code
                reginfo2.state = this.wxregtoken.state
                constJ.reqWXRegLoginV2(reginfo2).then(res => {
                    console.log(res)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            //注册成功
                            this.modalSetPwd = false;
                            this.updateUser(res, false)
                            this.$Message.success('微信扫码注册成功');
                        } else if (res.rltcode === -1021) {
                            //验证码无效
                            this.modalSetPwd = false;
                            //重输验证码
                            this.createWxAccfailure()
                            //清空验证码
                            this.$refs.userinfo.cleanSmsCode()
                            this.$Message.error(res.rltdesc);
                        } else {
                            this.$Message.error(res.rltdesc);
                            return
                        }
                    } else {
                        this.$Message.error(res.rtndesc);
                        return

                    }
                })
                return
            }


            //正常账号注册
            regJ.reqRegV2(reginfo).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //注册成功
                        this.modalSetPwd = false;
                        this.$Message.success('账号注册成功');
                        
                        //this.modalLogin = true //pull login

                        //关联临时用户数据
                        var args = {
                            matchuserguid: store.state.user.userGuid,
                            reguserguid: res.userguid,
                        }
                        args = JSON.parse(JSON.stringify(args))//拷贝历史数据
                        this.updateUser(res)
                        //关联临时用户访问数据
                        setTimeout(() => {
                            regJ.reqLinkTempUser(args).then(res => {
                            console.log(res)
                            if (res.rtncode === 1) {
                                if (res.rltcode === 1) {
                                    console.log('关联临时用户数据成功')
                                }else{
                                    console.log('关联临时用户数据异常1')
                                    console.log(res.rltdesc)
                                }
                            }else{
                                console.log('关联临时用户数据异常1')
                                console.log(res.rtndesc)
                            }
                        })
                        }, 2000)
                        console.log('增加一次引导教学次数==>')
                        store.state.user.numberofguide=1

                    } else if (res.rltcode === -1021) {
                        //验证码无效
                        this.modalSetPwd = false;
                        //重输验证码
                        this.createAcc()
                        //清空验证码
                        this.$refs.userinfo.cleanSmsCode()
                        this.$Message.error(res.rltdesc);
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return

                }
            })




        },
        pwdSubmitok(pwd) {
            //console.log("请输入并确认您的密码...")
            let telnum = this.forgetpwddata.tel
            let smscode = this.forgetpwddata.sms
            regJ.reqSetPwd(telnum, pwd, smscode).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.showtips = false;
                        this.modalPwdSubmit = false;
                        this.$Message.success('密码重置成功!');
                        //this.$emit('pwdSubmitok');
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }

            })


        },
        editPassword(da) {
            //console.log("请输入并确认您的密码...")
            let oripwd = da.oripwd
            let newpwd = da.newpwd
            regJ.reqEditPwd(oripwd, newpwd).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.showtips = false;
                        this.modalEditPwd = false;
                        this.$Message.success('密码修改成功!');
                        this.$refs.editpwd.handleReset('formCustom')
                        //this.$emit('pwdSubmitok');
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }

            })


        },
        pwdSubmitCancel() {
            this.modalPwdSubmit = false;
            this.loginCannel()
        },
        login_err() {
            this.isLoginButtonDisable = false;
        },
        update_login_state() {
            console.log("===============================>")
            console.log(this.sta)
            this.modalLogin = false;
            this.showLoginBtn = false;
            this.buttonSize = "small";
            this.buttonColor = "#2db7f5"
            this.showLoginUserMenu = true;
            this.isLoginButtonDisable = false; //登录成功，修改登录按钮为正常
            //刷新下拉
            this.$refs.myUserMenu.refreshDroplist();
            this.$emit('reloadDoc')
        },
        //构建并刷新一洽会员数据（暂停服务，2024.7.2）
        setECHATUserData(user) {
            try {
                var str1 = WECHAT.wxEncrypt("<xml>" +
                    "<nickName><![CDATA[" + user.userid + "]]></nickName>" +
                    "<phone><![CDATA[" + user.mobile + "]]></phone>" +
                    "</xml>", "NjQ2N2UwYmRkMmRmNDc3NTg4Y2VjOWJmNTlmNjg4MTg", "63DF7DD8DCF68A5BE0D571BF30207C98");
                //（暂停服务，2024.7.2）
                //ECHAT.refreshVisitorMetaData(str1.toString(), '')
                console.log('process finished===>')
            } catch (err) {
                console.log('ECHAT has an error ===>')
                console.log(err)
            }
        },
        login_ok() {
            console.log("login_ok,this.modalLogin->false")
            //console.log(this.sta)
            //console.log(ECHAT)
            //控制账号下拉菜单显示项
            //this.$refs.myUserMenu.showAuthority()
            //控制登录状态变化
            this.modalLogin = false;
            this.showLoginBtn = false;
            this.buttonSize = "small";
            this.buttonColor = "#2db7f5"
            this.showLoginUserMenu = true;
            this.isLoginButtonDisable = false; //登录成功，修改登录按钮为正常
            //this.$router.go(0)
            //this.initUserFolder() //登录成功，初始化用户默认文件夹
            // let sliders=this.getSliders()
            // let a = JSON.stringify(sliders)
            // var r = JSON.parse(a)
            //登录成功时重载doc内容
            this.$emit('reloadDoc')
            //this.$emit('loginOK')

            //路由不在商城则判断权限
            let routername = this.$router.history.current.name
            console.log(routername)

            if (routername !== 'userstore') {
                //this.getUserPermission()
                //仅登录时提示
                Promise.all([this.getProducts()]).then(res => {
                    let state = this.sta
                    this.initUserFolder()
                    this.checkAccountStatus(state)
                });
            }

            //如果是在搜索引擎路由下登录则重置查询信息
            if (routername === "usersearch") {
                eventBus.$emit("user-refresh-searchengine")
            }

            //登录完成，处理刷新页面权限
            console.log("处理this.loginSrc=" + this.loginSrc)
            if (this.loginSrc === "2") {
                //this.$router.push('search')
                //刷新
                eventBus.$emit("user-refresh-newlist")
            }
            //登录完成，处理跳转和渲染风险检测页面，同时是点击立即检测拉起的登录
            if (routername === "riskdetection" && this.loginSrc === "6" ){
                eventBus.$emit("access_tax_risk_detection")
            }
            // else if(this.loginSrc==="2"){
            //      //刷新
            //     eventBus.$emit("user-refresh-localnewlist")
            // }
            // console.log(r)
            //刷新一洽数据
            // console.log('刷新客服信息,屏蔽手机号码==>')
            // let user = {
            //     userid: this.sta.userId,
            //     mobile: ''
            //     //mobile: this.sta.mobileNum
            // }
            //（暂停服务，2024.7.2）
            //this.setECHATUserData(user)
        },
        checkAccountStatus(sta) {
            // //判断是否是第一次登录
            // let firstShowMsg = "欢迎您试用，您享有30天的免费试用期，购买账号等级，享有更多账号权益！"
            // //账号试用期到期前7天开始，登录账号时，提示信息如下
            // //每天登录时均提示，交付同上，时间递减，
            // let sevenDaysAlert = "您的账号试用期将于七天后到期，请于账号试用期到期前通过“在线商城”购买账号等级，享有更多账号权益！"
            // //最后一天的提醒
            // let lastDayAlert = "您的账号试用期今天到期，为了不影响您正常使用，请及时通过“在线商城”购买账号等级，享有更多账号权益！"
            // //账号试用期到期未购买账号等级的，则于试用期到期次日，登录账号时，提示信息如下：
            // //冻结期内，登录均这样提示。
            // let unregistinfo = "您的账号已进入30天的冻结期（至2021年11月30日止），您可通过“在线商城”购买账号等级解除账号冻结，冻结期满仍未购买账号等级的，将注销账号并解除与手机号码的绑定。"

            // //账号服务期到期前7天开始，登录账号时，提示信息如下
            // //每天登录时均提示，交付同上，时间递减
            // let sevenServiceDayAlert = "您的账号服务期将于七天后到期，请于账号服务期到期前通过“在线商城”续购账号等级，持续享有账号权益！"
            // //只是最后一天，提示如下
            // let lastServiceDayAlert = "您的账号服务期今天到期，为了不影响您正常使用，请及时通过“在线商城”续购账号等级，持续享有账号权益！"
            // //账号服务期到期未续购账号等级的，则于服务期到期次日，登录账号时，提示信息如下：
            // let endServiceFreezingInfo = " 您的账号已进入30天的冻结期（至2021年11月30日止），您可通过“在线商城”续购账号等级解除账号冻结，冻结期满仍未续购账号等级的，将注销账号并解除与手机号码的绑定。"


            //test
            //store.state.user.accounttype=3

            //console.log(sta)
            let accountStatus = this.sta.accountstatus
            let accounttype = this.sta.accounttype
            let permission = this.sta.permission
            let msg = this.sta.showmsg

            //测试
            // accountStatus = 107
            // msg = lastServiceDayAlert
            console.log(accountStatus, accounttype, permission)

            //处理登录提示,300和400冻结控制单独处理
            if (msg !== '') {
                if (accountStatus === 300 || accountStatus === 400) {
                    return
                } else {
                    this.modalCheckStatus = true
                    this.showServerMessage = msg
                }

                // if (accountStatus === 200) {
                //     console.log('当前用户账号状态:正常使用')
                // } else if (accountStatus === 100) {
                //     console.log('当前用户账号状态:试用期')

                // } else if (accountStatus === 107) {
                //     this.modalCheckStatus = true
                //     this.showServerMessage = msg
                //     console.log('当前用户账号状态:试用期到期7天内')
                // } 
                // // else if (accountStatus === 300) {
                // //     this.modalCheckStatus = true
                // //     this.showServerMessage = msg
                // //     console.log('当前用户账号状态:试用期满进入冻结期')
                // // } 
                // else if (accountStatus === 207) {
                //     this.modalCheckStatus = true
                //     this.showServerMessage = msg
                //     console.log('当前用户账号状态:正常使用到期7天内')
                // }
                // if (accountStatus === 400) {
                //     this.modalCheckStatus = true
                //     this.showServerMessage = msg
                //     console.log('当前用户账号状态:正常使用到期进入冻结期')
                // }
                // if (accountStatus === 500) {
                //     this.modalCheckStatus = true
                //     this.showServerMessage = msg
                //     console.log('当前用户账号状态:等待注销')
                // }
            } else if (this.sta.isupbaseproductnotice) {
                this.modalShowOtherNotice = true
                this.showServerOtherMessage = '已为您免费升级至专业版，谢谢您的支持与厚爱！'
            }



            // console.log(status)

        },
        //所有路由弹出提示框（除商城）
        freezePeriod() {
            console.log('处理冻结情况')
            let accountStatus = this.sta.accountstatus
            let msg = this.sta.showmsg
            //accountStatus=400
            if (accountStatus === 400 || accountStatus === 300) {
                this.modalCheckPermission = true
                this.loginMsg = msg
                //console.log("正常使用到期进入冻结期")
            }

            // if (accountStatus === 300) {
            //     this.modalCheckPermission = true
            //     this.loginMsg = msg
            //     //console.log("正常使用到期进入冻结期")
            // }
        },

        //所有路由弹出提示框（除商城）
        // getUserPermission() {
        //     console.log('获取用户permission')
        //     constJ.reqGetUserPermission().then(res => {
        //         console.log(res)
        //         let accountStatus=this.sta.accountstatus
        //         let msg = this.sta.showmsg
        //         let productorders = store.state.user.myvippackage
        //         if (res.rltcode === 1 && res.rtncode === 1) {
        //             if (res.items) {
        //                 if(accountStatus===400){
        //                     this.modalCheckPermission = true
        //                     this.loginMsg=msg
        //                     console.log("正常使用到期进入冻结期")
        //                     return
        //                 }

        //                 if (res.items.length <= 0 || productorders.length <= 0) {
        //                     this.modalCheckPermission = true
        //                     console.log("权限列表数据为空或购买的会员等级为空")
        //                     return
        //                 }

        //             } else {
        //                 //权限返回null
        //                 this.modalCheckPermission = true
        //                 return
        //             }

        //             //check
        //             // let state= this.sta

        //             //测试锁定登录
        //             //this.modalCheckPermission = true

        //         }
        //     })
        // },
        getProducts(isRenewVip = false) {
            console.log('登录获取套餐包信息==========>')
            console.log("isRenewVip:" + isRenewVip)

            //test
            //this.getWXUrl()

            //处理冻结
            this.freezePeriod()
            if (store.state.user.mallver === 'v1') {
                constJ.reqGetProducts().then(res => {
                    console.log('v1====>')
                    console.log(res)
                    if (res.rtncode == 1) {
                        if (res.rltcode == 1) {
                            store.state.user.myvippackage = res.data.effectiveorders.length > 0 ? res.data.effectiveorders : []
                            store.state.user.myproducts = res.data.products.length > 0 ? res.data.products : []
                            this.getProductPackages(isRenewVip)
                        } else {
                            this.$Message.warning(res.rltdesc)
                            return
                        }
                    } else {
                        this.$Message.warning(res.rtndesc)
                        return
                    }
                })
            } else if (store.state.user.mallver === 'v2') {
                // constJ.reqGetProductsV2().then(res => {
                //     console.log('v2====>')
                //     console.log(res)
                //     if (res.rtncode == 1) {
                //         if (res.rltcode == 1) {
                //             store.state.user.myvippackage =[]
                //             store.state.user.myproducts = res.data.products.length > 0 ? res.data.products : []
                //         } else {
                //             this.$Message.warning(res.rltdesc)
                //             return
                //         }
                //     } else {
                //         this.$Message.warning(res.rtndesc)
                //         return
                //     }
                // })
            }

        },
        getProductPackages(isRenewVip = false) {
            console.log("获取vip升级包信息=================>")

            //设置当前套餐信息
            // this.productId = store.state.user.myvippackage[0].productcode
            // this.productOrderId = store.state.user.myvippackage[0].orderid
            // this.radioproducts = store.state.user.myvippackage
            let productId = ''
            let productOrderId = ''
            if (store.state.user.myvippackage.length > 0) {
                productId = store.state.user.myvippackage[0].productcode
                productOrderId = store.state.user.myvippackage[0].orderid
            } else {
                return
            }


            constJ.reqProductPackages(productId, productOrderId).then(res => {
                console.log(res)


                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        store.state.user.myextentionpackage = res.items.funcs.length > 0 ? res.items : []
                        //存入session
                        let p = {
                            myvippackage: store.state.user.myvippackage,
                            myextentionpackage: store.state.user.myextentionpackage,
                            myproducts: store.state.user.myproducts,
                        }
                        store.commit('setLoginUserProductInfo', p)
                        //重载我的账号组件
                        eventBus.$emit("myproducts-reload")
                        //是否拉起续费vip组件
                        if (isRenewVip) {
                            console.log('拉起续费vip组件====>')
                            if (store.state.user.myvippackage.length > 0) {
                                let max = store.state.user.myvippackage.length - 1
                                let item = store.state.user.myvippackage[max]
                                this.reBuildVipData(item)
                            }
                        }
                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }



                // if (res.rltcode === 1 && res.rtncode === 1) {
                //     // this.plist = res.items.funcs
                //     // this.orderDays = res.items.days
                //     //this.getPackageDiscountInfo(this.plist)




                //     //更新权限
                //     //this.getUserPermission()

                // }
            })
        },
        reBuildVipData(item) {
            console.log(item)
            this.showvippaymodal(item)
        },
        initUserFolder() {
            console.log("initUserFolder====>")
            constJ.reqCreateDefault().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        console.log('登录成功,初始化文件夹')
                        //this.getFixedFolder()
                        this.getFolderTree()
                        //console.log(res)
                        //this.handleSetTree(res.datas)
                        //lunch
                        eventBus.$emit("lunch-guide")
                    } else {
                        console.log(res.rltdesc)
                        //reject(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                    //reject(res.rtndesc)
                }
            }).catch(err => {
                console.log(err)
            })
        },


        //*****************************************************************************
        //获取全量文件夹树
        //修改key
        changeTreeDate(jsonObj, newKey, oldKey) {
            let str = JSON.stringify(jsonObj);
            let reg = new RegExp(oldKey, 'g');
            let newStr = str.replace(reg, newKey);
            return JSON.parse(newStr);
        },
        //递归增加expand,_select,默认为false
        addAttribute(childrens) {
            childrens.forEach(item => {
                if (item.is_root) {
                    //展开第一层
                    item.expand = true
                    item._select = false
                } else {
                    item.expand = false
                    item._select = false
                }

                if (item.children && item.children.length > 0) {
                    this.addAttribute(item.children)
                }
            })
        },
        //获取文件夹树
        getFolderTree() {
            constJ.reqGetFolderTree().then(res => {
                console.log('getFolderTree==>')
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //修改根节点
                        if (res.data.tree.is_root) {
                            res.data.tree.dir_name = '全部文件归档'
                        }
                        // this.folderNumbersUsed = res.data.numberoffolders
                        var data = []
                        data.push(res.data.tree)
                        //处理数据1，修改key name：title，value
                        let data_tree = this.changeTreeDate(data, 'title', 'dir_name')
                        data_tree = this.changeTreeDate(data_tree, 'value', 'dir_id')
                        //递归增加属性expand，_select
                        this.addAttribute(data_tree)
                        var str = JSON.stringify(data_tree)
                        let _data = JSON.parse(str)
                        //更新数据
                        store.state.user.myfolders = _data

                    }
                }
            })
            
        },
        //*****************************************************************************

        //原有固定文件夹，停用2021.09.07
        getFixedFolder() {
            constJ.reqGetFixedFolder().then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        console.log('开始获取固定文件夹..')
                        console.log(res)
                        let folderData = this.setFolderData(res.item)
                        console.log(folderData)
                        store.state.user.folder.data = folderData
                        //this.handleSetTree(res.datas)
                    } else {
                        console.log(res.rltdesc)
                        //reject(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                    //reject(res.rtndesc)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        setFolderData(items) {
            let data = {}
            data.header = [{
                title: "文件夹名称",
                key: "filename",
                align: "left"
            }]
            data.tabname = 'tbl'
            data.pageindex = 1
            data.total = 10
            data.tabrows = []
            if (items !== undefined && items.length > 0) {
                for (var item of items) {
                    var row = {}
                    row.foldername = item.dir_name
                    row.folderid = item.dir_id
                    row.filetype = 2
                    row.desc = ""
                    row.parent_dir_id = item.parent_dir_id
                    row.is_root = item.is_root
                    row.is_fixed = item.is_fixed
                    row._checked = false
                    row._disabled = false
                    data.tabrows.push(row)
                }
            }
            return data
        },

        resetWXtoken(value) {
            console.log("提交验证...")
            let telnum = value.tel
            let smscode = value.sms
            let src = value.smstypecode
            regJ.reqRegCheckSmsCode(telnum, smscode, src).then(res => {
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        regJ.reqSetWXToken(smscode).then(res => {
                            if (res.rtncode === 1) {
                                if (res.rltcode === 1) {
                                    this.modalResetWxToken = false;
                                    this.$Message.success('微信关联已重置')
                                    this.reloadUser()
                                } else {
                                    this.$Message.error(res.rltdesc);
                                    return
                                }
                            } else {
                                this.$Message.error(res.rtndesc);
                                return
                            }
                        })
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            })
        },
        pwd_ok(value) {
            console.log("提交验证...")
            let telnum = value.tel
            let smscode = value.sms
            let src = value.smstypecode
            regJ.reqRegCheckSmsCode(telnum, smscode, src).then(res => {
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.forgetpwddata = value
                        this.modalPwd = false;
                        this.modalPwdSubmit = true;
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            })
        },
        clear() {
            this.$nextTick(function() {
                if (this.modal1) {
                    this.$refs.userinfo.handleReset('formCustom');
                    // this.$refs.userinfowxreg.handleReset('formCustom');
                    //this.$refs.userreg2.handleReset('formCustom');
                }
                if (this.modalLogin) {
                    if (this.loginType === 1) {
                        this.$refs.ulogin.handleReset('formCustom'); //登录
                    }
                    if (this.loginType === 2) {
                        this.$refs.uSmsLogin.handleReset('formCustom');
                    }
                }
                if (this.modalPwd) {
                    this.$refs.upwd.handleReset('formCustom'); //设置密码
                    this.$refs.getpwdsubmit.handleReset('formCustom');
                }
                if (this.modalResetWxToken) {
                    this.$refs.resetwxtoken.handleReset('formCustom');
                }
                if (this.modalSetPwd) {
                    this.$refs.userregsetpwd.handleReset('formCustom'); //找回密码短信认证
                }
                if (this.modalPwdSubmit) {
                    this.$refs.getpwdsubmit.handleReset('formCustom'); //找回密码确认
                }
                if (this.modalChangePhone) {
                    this.$refs.cpInfo.handleReset('formCustom'); //修改手机号码-验证身份
                    this.$refs.cpsInfo.handleReset('formCustom');
                }
                if (this.modalBindPhone) {
                    this.$refs.myBindPhone.handleReset('formCustom')
                }

            })
        },
        showlogin() {
            console.log("showlogin====>" + this.modalLogin, "loginTyp====>" + this.loginTyp)
            this.clear()
            this.modalLogin = true
            //this.backUrl = ""
            // if(this.loginType!==2){
            //   this.modalLogin = true
            // }

            //this.modal1 = true;
        },
        otherShowlogin(backUrl) {
            console.log("otherShowlogin:" + backUrl)
            this.clear();
            this.backUrl = backUrl
            this.modalLogin = true
            //this.modal1 = true;
        },

        loginCannel() {
            //console.log(this.$route)
            console.log("login-cannel======>")
            //停用轮询
            if (this.$refs.mywechatlogin2) {
                this.$refs.mywechatlogin2.isQueryWXState = false
                this.$refs.mywechatlogin2.closeQRCode()
            }

            this.loginTabValue = '1'
            this.loginType = 1
            this.isShowLoginFooter = true
            console.log(this.modalLogin)
            console.log("loginCannel,this.modalLogin=>false")
            this.modalLogin = false;
            this.modalSetPwd = false;
            if (this.$route.meta.requireLogin) {
                if (store.state.user.userId === undefined || store.state.user.userId === "") {
                    this.$router.push({ path: this.home });
                }
            }
            this.isLoginButtonDisable = false
            eventBus.$emit("login-cannel", "true")
            // if (this.backUrl !== "") {
            //   this.$router.push({ path: this.backUrl });
            // }

            //重置弹出登录窗体状态
            //store.commit("setLoginForm", false)

            //this.$Message.info('Clicked cancel');
        },
        lockLoginButton() {
            console.log('lockLoginButton')
            this.isLoginButtonDisable = true
        },


        //登录
        loginSubmit() {
            console.log("this.loginType:" + this.loginType)
            if (this.loginType === 1) {
                this.$refs.ulogin.handleSubmit('formCustom');
            } else {
                //验证码登录
                this.$refs.uSmsLogin.handleSmsLogin('formCustom');
            }
        },

        regSetPwdSubmit() {
            //this.$refs.userregsetpwd.handleSubmit('formCustom');
            this.$refs.userreg2.handleSubmit();
        },
        editPwdSubmit() {
            this.$refs.editpwd.handleSubmit('formCustom');
        },
        wxTokenCancel() {
            this.modalResetWxToken = false
            this.loginCannel()
        },
        rdCancel() {
            this.modalRiskDetection = false;
            // this.loginCannel()

        },
        pwdCancel() {
            this.modalPwd = false;
            this.loginCannel()
            //this.$Message.info('Clicked cancel');
        },
        pwdEditCancel() {
            this.modalEditPwd = false
            this.$refs.editpwd.handleReset('formCustom');
        },
        pwdSubmit() {
            this.$refs.upwd.handleSubmit('formCustom');
        },

        wxResetTokenSubmit() {
            this.$refs.resetwxtoken.handleSubmit('formCustom');
        },

        cpCancel() {
            this.modalChangePhone = false;
            //this.loginCannel()
            //this.$Message.info('Clicked cancel');
        },
        cpSubmit() {
            this.$refs.cpInfo.handleSubmit('formCustom');
        },
        cpsCancel() {
            this.modalChangePhoneSubmit = false;
            //this.loginCannel()
            //this.$Message.info('Clicked cancel');
        },
        cpsSubmit() {
            this.$refs.cpsInfo.handleSubmit('formCustom');
            //this.modalChangePhoneSubmit = true;
            //this.$Message.error('更换手机号码失败，失败原因:XXXXX')

            // this.modalChangePhoneSubmit = false;
            // this.$Message.success('更换手机号码成功')
            //this.$refs.upwd.handleSubmit('formCustom');
        },
        //绑定手机号码
        bindPhoneCancel() {
            this.modalBindPhone = false;
        },
        bindPhoneSubmit() {
            this.$refs.myBindPhone.handleSubmit('formCustom');
        },
        getPwdSubmit() {
            this.$refs.getpwdsubmit.handleSubmit('formCustom');
        },

        // autoClearDocs(){
        //      let selected = this.getSliders()
        //      console.log(selected)
        //      //this.$emit('removeAll', selected)
        // },

        sumitClearDocs() {
            let selected = this.$refs.DocMng.getSelected()
            // console.log(this.$refs.DocMng)

            this.$emit('removeAll', selected)
            this.modalPages = false
            //console.log(selected)
        },
        ClearDocsCancel() {
            this.modalPages = false
            this.loginCannel()
        },
        closeUserinfo() {
            this.modalUserInfo = false
        },

        //判断微信是否已注册
        checkWxTokenIsReged(wxtoken) {
            console.log('checkWxTokenIsReged===>')
            this.weixinLogin(wxtoken)
        },
        //微信拉起注册
        createWxAcc2(wxtoken) {
            //注册完毕需要清空token
            console.log('createWxAcc2===>', wxtoken)
            this.wxregtoken = wxtoken
            this.clear()
            this.modalLogin = false;
            this.regTabValue = "3"
            this.isWxRegGetTelNum = true
            this.modal1 = true;
            //清空input
            this.$refs.userinfowxreg.handleReset('formCustom')
        },
        createWxAccfailure() {
            this.clear()
            this.modalLogin = false;
            this.modal1 = true;
        },
        createAcc() {
            console.log('点击注册===>')
            this.clear()
            this.wxRegTokenClear()
            this.isWxRegGetTelNum = false
            this.modalLogin = false;
            this.modal1 = true;
        },
        passwdReset() {
            this.clear()
            this.modalLogin = false;
            this.modalPwd = true;

        },
        passwdEdit() {
            this.clear()
            this.modalEditPwd = true
        },
        showUser() {
            this.modalUserInfo = true
        },
        showMngPwd() {
            this.modalManagePwd = true
        },
        showpaymodal(row) {
            //处理团购(非自用)-不能续费账号等级，可以续费vip升级权限
            //团购(非自用)主产品不能直接续费，点击个人中心的续费按钮跳转到商城，按商城正在销售的产品购买

            // let accounttype = this.sta.accounttype
            // var that = this
            // if (accounttype === 4) {
            //     this.$Modal.warning({
            //         title: "提示",
            //         content: "请前往商城购买账号等级",
            //         onOk: function() {
            //             that.$router.push('userstore')
            //         },
            //     })
            //     return
            // }

            this.modalPay = true
            this.modalMyVip = false
            this.$refs.uPay.loadDefaultPackages(row)
            //console.log(this.$refs.uPay.formData)
        },
        showvippaymodal(row) {
            this.modalVipPay = true
            this.modalMyVip = false
            this.$refs.uVipPay.loadDefaultPackages(row)
            //console.log(this.$refs.uPay.formData)
        },
        commitVipRenewalData() {
            this.$refs.uVipPay.checkOrder()
        },
        commitRenewalData() {
            //this.$refs.uPay.showPayModal()
            this.$refs.uPay.checkOrder()

            //let a= this.$refs.uPay.vipData
            // console.log(a)
            // console.log(this.$refs.uPay.userData)
        },
        closevippaymodal() {
            this.modalVipPay = false
        },
        closepaymodal() {
            this.modalPay = false
        },
        showvipmodal() {
            this.modalMyVip = true
            //this.$refs.myVipPage.show()
        },
        showcp() {
            this.clear()
            this.modalChangePhone = true
        },
        showbp() {
            this.clear()
            this.modalBindPhone = true
        },
        showrwt() {
            this.clear()
            this.modalResetWxToken = true
        },
        showPromoCode() {
            this.clear()
            this.modalPromo = true
            this.$refs.promocode.loadUI()
        },
        showMyCustomer(){
            this.clear()
            this.modalCustomer=true
        },
        showsmswxaccount() {
            this.clear()
            this.modalEditAccountSmsCode = true
        },
        cancelBindWx() {
            this.clear()
            if (this.$refs.mywechatbind2) {
                this.$refs.mywechatbind2.isQueryWXState = false
                this.$refs.mywechatbind2.closeQRCode()
            }
            this.modalBindWechat = false
        },
        cancelDistributor() {
            this.modalBindDistriButor = false
            this.clear()
        },
        cancelPromo() {
            this.modalPromo = false;
            this.clear()
        },
        cancelCustomer(){
            this.modalCustomer=false;
            this.clear()
        },
        cancelsmswxaccount() {
            this.modalEditAccountSmsCode = false;
            this.clear()
        },
        checkSmsWxEditAcc() {
            this.$refs.smsCheckMyWxAcc.handleSubmit('formCustom')
        },
        wxCheckSmsOK(da) {
            // if(da.type===1){
            //     this.wxMergeChecksms(da)
            // }else if(da.type===2){
            //     this.reg_ok(da)
            // }
            this.reg_ok(da)

        },
        closeMngPwd() {
            this.modalManagePwd = false
        },
        userLogout() {
            this.showLoginBtn = true;
            this.showLoginUserMenu = false;
            this.buttonSize = "default";
            this.buttonColor = "#808695"
            this.handleSetUserLogout()
            //this.$router.go(0) //通知app.vue临时登录,注销原来跳转到search?t=0
            //window.location.reload()
        },
        onMenuSelect(args) {
            if (args === "3") {
                //add favorite
                // let rlt= addFavorite("http://localhost:8080/main/searchengine/","Doc");
                // if(rlt!==true){
                //  this.$Message.warning(rlt);
                // }
                var list = this.getSliders()
                this.$refs.DocMng.bindData(list)
                this.modalPages = true
                //console.log(list)
            } else if (args === "2") {
                this.clear();
                this.modal1 = true
            } else if (args === "0") {
                this.switchMessageBoard()
                console.log('click------->')
                //console.log(this.$refs.msgList)
            } else if (args === "11") {
                console.log('税收优惠政策匹配==>')
                this.$router.push('matchfile')
            }
        },
        directto1() {
            this.$router.push('matchfile')
            this.$emit('matchfile')
        },
        showMultiBtn(state) {
            this.showMultiScreenBtn = state
        },
        nothing() {
            return
        },
        //检测是否注册微信并提示是否登录
        checkIsWxRegUser(res) {
            this.$Modal.confirm({
                title: '提示',
                content: '<p>系统检测到您已完成微信注册，是否登录？</p>',
                cancelText: "否",
                okText: '是',
                onOk: () => {
                    //this.weixinLogin(po)
                    //刷新登录数据
                    this.updateUser(res)
                },
                onCancel: () => {
                    return
                }
            });
        },
        //微信注册流程中，获取微信token之后，判断是否已存在此微信id，
        //存在询问用户是否自动登录，不存在则进入微信正常注册逻辑
        weixinLogin(po) {
            constJ.reqWXLogin(po).then(res => {
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //登录成功
                        //刷新登录数据
                        //this.updateUser(res)
                        this.checkIsWxRegUser(res)
                        //如果已经是微信注册用户且购买了会员等级，弹出提示是否修改账号(前三天每天登录提示)

                    } else if (res.rltcode === -3) {
                        //注册并登录
                        //this.checkIsWxUser(po)
                        this.createWxAcc2(po)

                    } else {
                        console.log(res.rltdesc)
                        this.$Modal.info({
                            title: '提示',
                            content: res.rltdesc
                        });
                        //this.$Message.warning(res.rltdesc)
                        return
                        //reject(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                    this.$Modal.info({
                        title: '提示',
                        content: res.rtndesc
                    });
                    //this.$Message.warning(res.rltdesc)
                    return
                    //reject(res.rtndesc)
                }
            })
        },
        //更新登陆数据
        updateUser(res, isWxMember = false) {
            var wxLoginUser = {
                userGuid: res.userguid,
                userId: res.userid,
                mobileNum: res.mobilenum,
                realName: res.realname,
                token: res.token,
                userType: res.userid, //手动登录成功，将用户id写入userType,以区别临时用户,普通用户和企业用户
                //accounttype: res.accounttype, //  0-临时用户, 1-个人用户,2-单位用户, 3-单位用户(固定IP),4-团购用户
                permission: res.permission,
                accounttype: res.accounttype,
                accountstatus: res.accountstatus,
                freefolder: res.freefolder,
                showmsg: res.showmsg,
                wxopenid: res.wxopenid,
                wxunionid: res.wxunionid,
                wxgenerateid: res.wxgenerateid,
                showmallbutton: res.showmallbutton,
                mallver: res.mallver,
                maxopendocnum: res.maxopendocnum,
                opendocnum: res.opendocnum,
                email: res.email
            }
            store.commit('setLoginUser', wxLoginUser)
            //第一个true=是否更新登录状态，第二true=是否拉起修改账号
            this.login_ok()
        },
        ...mapActions(['handleTempLogin', 'handleSetUserLogout', 'flashToken']),
        // ...mapActions(['handleSetLoginUserinfo']),
    },
    computed: {
        ...mapGetters(['sta', 'getLoginForm'])

    },
    components: {
        // "Printer": Printer,
        "Distributor": bindDistributor,
        "MyPromo": mypromo,
        "MyCustomer":mycustomer,
        "WechatBind": wechatbind,
        "WechatReg": wechatreg,
        "WechatLogin": wechatLogin,
        "WechatLoginCustom": wechatLoginCustom,
        "SMSEditWeAcc": SmsCodeEditWXAccount,
        "UserReg": UserReg,
        "UserLogin": UserLogin,
        "UserMenu": UserLoginMenu,
        "UserPwd": UserPassword,
        "UserRegSetPwd": UserSetPwd,
        "UserReg2": UserReg2,
        "GetPwdSubmit": GetPwdSubmit,
        "EditPwd": EditPwdSubmit,
        "DocManage": DocManage,
        "SmsLogin": SmsLogin,
        "UserInfo": UserInfo,
        "ManagePwd": ManagePwd,
        "Agreement": Agreement,
        "Statement": Statement,
        UserResetWXToken,
        ChangePhone,
        BindPhone,
        ChangePhoneSubmit,
        UserVipPackagePay,
        MyVip,
        UserProductPay,
    },
    watch: {
        '$route'(to, from) {
            console.log("watch route...")
            console.log(to)
            if (to.name === 'usermanual') {
                return true
            }
            let fromUrl = from.path
            //console.log("to："+to.meta.requireLogin)
            if (to.meta.requireLogin) {
                if (store.state.user.userId === undefined || store.state.user.userId === "") {
                    this.otherShowlogin(fromUrl)
                }
            }
            //监听路由并验证登录用户权限
            if (this.checkUserLogin()) {
                //验证权限
                console.log('验证权限：' + to.name)
                if (to.name === "userstore") {
                    this.removeAllSliders()
                }
                if (to.name === "matchfile") {
                    this.removeAllSliders()
                }

                if (to.name !== "userstore") {
                    this.getProducts()
                    //关闭窗口
                    //this.getUserPermission()
                }
                // if (to.name === "riskdetection") {
                //     console.log("access riskdetection===>")
                //     eventBus.$emit("access_tax_risk_detection")
                // }
                //刷新一洽客服数据
                // let user = {
                //     userid: this.sta.userId,
                //     mobile: ''
                //     // mobile:'': this.sta.mobileNum
                // }
                //（暂停服务，2024.7.2）
                //this.setECHATUserData(user)
            }
        },
        getLoginForm: function() {
            console.log("getLoginForm:" + this.getLoginForm)
            console.log("getLoginForm:" + this.loginType)
            if (this.getLoginForm === true) {
                this.showlogin()
            } else {
                //this.userLogout()
                //this.$router.push({name:'search',query:{t:0}})//通知app.vue临时登录
                //this.handleTempLogin()
            }
        },
        modalLogin: function(value) {
            if (this.modalLogin === false) {
                console.log("topheader重置弹出登录窗体状态:false")
                store.commit("setLoginForm", false)
            } else {
                //this.showlogin()
            }
            console.log('modalLogin:' + value)
        },
        // getUserType: function() {
        //   //普通用户登录或企业用户登录,隐藏申请试用菜单
        //   console.log("getUserType:"+this.getUserType)
        //   if (this.getUserType !== "" && this.getUserId !== "" && this.getUserType !== "temp") {
        //     this.showRequestTrial=false
        //   }
        // }

        getAccountType: function() {
            console.log("getUserId========>")
            console.log(this.getUserId, this.getAccountType)
            if (this.getUserId === "" || this.getAccountType === 0) {
                this.userLogout()
            }
        }


    }

}
</script>
<style lang="scss" scoped>
$logo-font-size: 28px;
$logo-font-farmily: Microsoft JhengHei;

//登录modal
.userloginpannel/deep/.ivu-modal-body {
    padding: 0px;
}

// tabs居中
.tablogin/deep/.ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
}

//注册modal
.userregpannel/deep/.ivu-modal-body {
    padding: 0px;
}

//重置密码
.pwdresetpannel/deep/.ivu-modal-body {
    padding: 0px;
}

//重置密码-确认密码
.pwdresetpannel2/deep/.ivu-modal-body {
    padding: 0px;
}

//修改密码
.editpwdpannel/deep/.ivu-modal-body {
    padding: 0px;
}

//关联微信
.linkwxpannel/deep/.ivu-modal-body {
    padding: 0px;
}

//重置关联微信
.resetlinkpannel/deep/.ivu-modal-body {
    padding: 0
}

.phoneresetpannel/deep/.ivu-modal-body {
    padding: 0
}
.customerpannel/deep/.ivu-modal-body {
    padding: 0
}

.panneltitle {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #000000;
}
.rdpanneltitle {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #000000;
}
.rddesctitle{
    padding-top:10px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    color: #165DFF;
}
.rdcontent{
    height: 100px;
    display: flex;
    // background-color: lightblue;
    justify-content: center;
    align-items: center;
    .div1{
        // font-size: 22px;
        // font-family: Microsoft YaHei;
        // color:#3491FA;
    }
    .divdot{
        font-size: 22px;
        font-family: PingFang SC;

    }
    .div2{
        // font-size: 22px;
        // font-family: Microsoft YaHei;
        // color:#165DFF;
    }
}
// tabs居中
.tabreg/deep/.ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
}


//申请试用按钮背景
.freetry {
    background-color: white;
    border-radius: 8px;
    height: 30px;
    width: 120px;
    text-align: center;
    line-height: 30px;
    vertical-align: middle;
    top: 15px;
    right: 10px;
}

.incentives2 {
    background-color: #FE6F37;
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
    vertical-align: middle;
    position: relative;
    display: block;
    cursor: pointer;
    width:35px;
    height: 35px;
    padding-top: 2px;
}
.incentives2:hover {
    border:1px solid #fff372;
    padding-top: 1px;
    box-shadow: 5px;
}

.incentives {
    background-color: #FE6F37;
    border-radius: 8px;
    height: 30px;
    width: 145px;
    text-align: center;
    line-height: 30px;
    vertical-align: middle;
    top: 0px;
    position: relative;
    display: block;
    cursor: pointer;

    // -webkit-user-select: none;
    // -moz-user-select: none;
    // -ms-user-select: none;
    // user-select: none;
    img {
        position: relative;
        top: 3px;
        left: -3px;
    }

    span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }

    span:hover {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FE9;
    }
}

//申请试用默认字体颜色
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu {
    color: #2b85e4;
}

//申请试用激活时候字体颜色
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu:hover {
    color: #ff9900;
}

//header背景色
.ivu-menu-dark {
    background: #1A84FF;
}

.layout {
    //border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 0px;
    overflow: hidden;
}

.layout-logo {
    padding-left: 10px;
    padding-top: 0px;
    width: 120px;
    // height: 30px;
    /* background: #5b6270; */
    border-radius: 3px;
    float: left;
    position: relative;
    //top: 8px;
    left: 10px;
    vertical-align: middle;
    //line-height: 30px;
    color: #fff;
    font-size: $logo-font-size;
    font-family: $logo-font-farmily;
}

.layout-nav-left {
    width: 520px;
    margin: 0 auto;
    margin-left: 200px;
}

.layout-nav-right {
    width: 450px; //450px 申请试用，登录，刷新组位置，（已预留出优惠匹配菜单空间）
    margin: 0 auto;
    margin-right: 0px;
}

.ivu-layout-header {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    background-color: white; //补差header背景色(5-10px)
    //  height:100px;
    // line-height: 80px;
}

// .ivu-menu-horizontal{
//   line-height:88px;
// }

.headerHeight {
    height: 60px;
}

.headerHeightDefault {}

.mp/deep/.ivu-modal-body {
    padding: 0px;
}

.mp/deep/.ivu-modal-header {
    background-color: #515a6e;
}

.vipmodal/deep/.ivu-modal-body {
    padding: 0px;
}

.vipmodal/deep/.ivu-modal-header {
    background-color: #FEE7AA;
}



// .fade-enter-active, .fade-leave-active {
//     transition: opacity 2s
// }
// .fade-enter, .fade-leave-to{
//     opacity: 0
// }


// .demo-badge {
//     width: 42px;
//     height: 42px;
//     background: #eee;
//     border-radius: 6px;
//     display: inline-block;
// }

.mitem/deep/.ivu-badge-dot {
    top: 15px;
    right: -5px;
}

.mitem {
    margin-top: 4px;
}

// .mitem/deep/.ivu-icon {
//     margin-top: 18px;
// }

//菜单项间距
.menuList/deep/.ivu-menu-item {
    padding: 0 10px;
}

.ivu-select-dropdown {
    top: 70px !important;
}

.messageboard {
    margin-top: 6px;
    color: red;
    position: absolute;
    top: 64px;
    background-color: white;
    width: 413px;
    height: 300px;
    border: 1px solid #dcdee2;
    display: block;
}

.messageboard2 {
    display: none;
}


#msgBoard/deep/.ivu-list-item {
    // padding-top: 10px;
}

#msgBoard/deep/.ivu-icon {
    padding-left: 10px;
}

// link bg

.linkdivider {
    display: block;
    position: absolute;
    height: 260px;
    top: 20%;
    width: 2px;
}

.wxlinkdiv {
    width: 300px;
    float: left;
    margin-right: 10px;
    height: 468px;
    // border-right: 2px solid #e8eaec;

}

.linelinktitle {
    width: 100%;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #323233;
    text-align: center;
    padding-bottom: 10px;
}

.linelink {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #2878FF;
    padding-top: 10px;
}

.linelink1 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #323233;
    padding-top: 10px;
}


//login bg txt
.line1 {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
}

.line2 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
}

.line3 {
    font-size: 16px;
    font-family: BMWTypeGlobalPro;
    font-weight: 300;
    color: #FFFFFF;
}

.refreshbtn/deep/.ivu-btn:hover {
    color: #ff9900;
}

</style>
<style>
/* intro css */
.introjs-skipbutton{
  font-size: 0.8rem !important;
  color:rgb(179, 182, 174);
}
.introjs-skipbutton:hover{
  font-size: 0.8rem !important;
  color:#fff !important;
}
</style>